export const NFT_SERVER_URL = 'https://api.hyaliko.com/getNFTs';
export const UPDATE_CANVASES_URL = 'https://api.hyaliko.com/updateCanvases';
export const REVERSE_ENS_URL = 'https://api.hyaliko.com/reverseENS';
export const GET_GALLERY_URL = 'https://api.hyaliko.com/getGallery';
export const UPDATE_GALLERY_URL = 'https://api.hyaliko.com/updateGallery';
export const CHECK_AUTHENTICATION_URL = 'https://api.hyaliko.com/checkAuthentication';

export const SPACE_GARDEN_ADDRESS = '0xd6c1693653b1145f01b4052c8a3fb5b1a13718dd';
export const SPACE_FACTORY_ADDRESS = '0xaE4109A8CfAfC5789F444b1aEF56605c2F6eAAD1';
export const SPACE_FACTORY_ABI = [
    { "inputs": [{ "internalType": "uint32", "name": "spaceIndex", "type": "uint32" }, { "internalType": "uint8", "name": "terrainColor", "type": "uint8" }, { "internalType": "uint8", "name": "backgroundColor", "type": "uint8" }, { "internalType": "uint8", "name": "particleShape", "type": "uint8" }, { "internalType": "uint8", "name": "particleColor", "type": "uint8" }], "name": "mintVariant", "outputs": ([] as any[]), "stateMutability": "payable", "type": "function" },
    { "inputs": [{ "internalType": "uint256", "name": "tokenId", "type": "uint256" }, { "internalType": "uint32", "name": "spaceIndex", "type": "uint32" }, { "internalType": "uint8", "name": "terrainColor", "type": "uint8" }, { "internalType": "uint8", "name": "backgroundColor", "type": "uint8" }, { "internalType": "uint8", "name": "particleShape", "type": "uint8" }, { "internalType": "uint8", "name": "particleColor", "type": "uint8" }], "name": "mintVariantWithHyalikoSpace", "outputs": ([] as any[]), "stateMutability": "nonpayable", "type": "function" },
    { "inputs": [{ "internalType": "address", "name": "owner", "type": "address" }], "name": "balanceOf", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" },
    { "inputs": [{ "internalType": "address", "name": "owner", "type": "address" }, { "internalType": "uint256", "name": "index", "type": "uint256" }], "name": "tokenOfOwnerByIndex", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" },
    { "inputs": [{ "internalType": "uint256", "name": "tokenId", "type": "uint256" }], "name": "ownerOf", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" }
];

export const SPACE_NAME_TO_ID: { [key: string]: number } = {
    metropolitan: 215,
    banquet: 225,
    abscission: 235,
    dungeon: 245,
    fission: 255
};


export const NFT_LIMIT = 200;
export const NFT_BATCH_SIZE = 50;

export const playSound = () => {
    // Play a little sound
    const r = 100 * Math.random();
    let randomIndex;
    if (r < 20) {
        randomIndex = 1;
    } else if (r < 40) {
        randomIndex = 3;
    } else if (r < 60) {
        randomIndex = 5;
    } else if (r < 70) {
        randomIndex = 2;
    } else if (r < 80) {
        randomIndex = 4;
    } else if (r < 90) {
        randomIndex = 6;
    } else if (r < 95) {
        randomIndex = 7;
    } else if (r <= 100) {
        randomIndex = 8;
    }
    const audio = document.getElementById(`sound${randomIndex}`) as HTMLAudioElement;
    if (audio) {
        audio.currentTime = 0;
        if (audio.paused) {
            audio.play();
        }
    }
};

export const COLOR_OPTIONS = [
    '#cccccc',
    '#7c7c7c',
    '#000000',
    '#00d081',
    '#AC8CFF',
    '#961fff',
    '#f29800',
    '#FE0302',
    '#980100',
    '#0BCDFE',
    '#4900FF'
];
export const BABYLON_COLOR_OPTIONS = COLOR_OPTIONS.map(c => BABYLON.Color3.FromHexString(c));

export const PARTICLE_COLOR_OPTIONS = [
    '#ffffff',
    '#7c7c7c',
    '#000000',
    '#00d081',
    '#961fff',
    '#0BCDFE',
    '#f29800',
    '#FE0302',
    '#4900FF'
];
export const BABYLON_PARTICLE_COLOR_OPTIONS = PARTICLE_COLOR_OPTIONS.map(c => BABYLON.Color3.FromHexString(c));

export const PARTICLE_SHAPE_OPTIONS = ['circle', 'triangle', 'square'];
export const PARTICLE_SHAPE_FUNCTIONS = [
    getCircleSvg,
    getTriangleSvg,
    getSquareSvg
];

export const BACKGROUND_COLOR_OPTIONS = [
    '#FFFFFF',
    '#7f7f7f',
    '#000000',
    '#86ffd1',
    '#87E8FF',
    '#E155FF',
    '#FFEA9B',
    '#FF5161',
    '#6577ff'
];
export const BABYLON_BACKGROUND_COLOR_OPTIONS = BACKGROUND_COLOR_OPTIONS.map(c => BABYLON.Color3.FromHexString(c));
export const BABYLON4_BACKGROUND_COLOR_OPTIONS = BACKGROUND_COLOR_OPTIONS.map(c => BABYLON.Color3.FromHexString(c).toColor4(1));

export function encodeSvg(svg: string) {
    return 'data:image/svg+xml;base64,' + window.btoa(svg);
}

export function getCircleSvg(color: string) {
    const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" height="150" width="150"><defs><radialGradient id="gradient"><stop stop-opacity="1" stop-color="${color}" offset="0" /><stop stop-opacity="0" stop-color="${color}" offset="0.9" /></radialGradient></defs><circle cx="32" cy="32" r="32" fill="url(#gradient)"></circle></svg>`;
    return encodeSvg(svg);
}

export function getSquareSvg(color: string) {
    const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" height="150" width="150"><rect width="32" height="32" x="16" y="16" fill="${color}"></rect></svg>`;
    return encodeSvg(svg);
}

export function getTriangleSvg(color: string) {
    const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" height="150" width="150"><polygon points="16,48 32,16 48,48" fill="${color}"></polygon></svg>`;
    return encodeSvg(svg);
}

export const TOKEN_DATA: { [key: number]: any } = {
    5: {
        rotationPoint: new BABYLON.Vector3(0, 0, 34),
        cameraPosition: new BABYLON.Vector3(0, 500, -800),
        cameraRotation: 20,
        scale: 1.2,
        yPosition: 0
    },
    6: {
        rotationPoint: new BABYLON.Vector3(0, 0, 32.6875),
        cameraPosition: new BABYLON.Vector3(0, 500, -800),
        cameraRotation: 20,
        scale: 1.2,
        yPosition: 0
    },
    7: {
        rotationPoint: new BABYLON.Vector3(0, 0, 52),
        cameraPosition: new BABYLON.Vector3(0, 500, -800),
        cameraRotation: 20,
        scale: 1.2,
        yPosition: 0
    },
    8: {
        rotationPoint: new BABYLON.Vector3(0, 0, 52.2),
        cameraPosition: new BABYLON.Vector3(0, 500, -800),
        cameraRotation: 20,
        scale: 1.2,
        yPosition: 0
    },
    9: {
        rotationPoint: new BABYLON.Vector3(0, 0, 34.34762),
        cameraPosition: new BABYLON.Vector3(0, 500, -800),
        cameraRotation: 20,
        scale: 1.2,
        yPosition: 0
    },
    16: {
        rotationPoint: new BABYLON.Vector3(0, 0, 53.4567),
        cameraPosition: new BABYLON.Vector3(0, 500, -800),
        cameraRotation: 20,
        scale: 1,
        yPosition: 0
    },
    26: {
        rotationPoint: new BABYLON.Vector3(0, 0, 70.0231),
        cameraPosition: new BABYLON.Vector3(0, 500, -800),
        cameraRotation: 20,
        scale: 1,
        yPosition: 0
    },
    36: {
        rotationPoint: new BABYLON.Vector3(0, 0, 40),
        cameraPosition: new BABYLON.Vector3(0, 500, -800),
        cameraRotation: 20,
        scale: 0.8,
        yPosition: 0
    },
    46: {
        rotationPoint: new BABYLON.Vector3(0, 0, 143.375),
        cameraPosition: new BABYLON.Vector3(0, 500, -800),
        cameraRotation: 20,
        scale: 0.6,
        yPosition: -50
    },
    56: {
        rotationPoint: new BABYLON.Vector3(0, 0, 30.8),
        cameraPosition: new BABYLON.Vector3(0, 500, -800),
        cameraRotation: 20,
        scale: 1.4,
        yPosition: -150
    },
    66: {
        rotationPoint: new BABYLON.Vector3(0, 0, 43.1),
        cameraPosition: new BABYLON.Vector3(0, 500, -800),
        cameraRotation: 20,
        scale: 1,
        yPosition: 0
    },
    76: {
        rotationPoint: new BABYLON.Vector3(0, 0, 84.5),
        cameraPosition: new BABYLON.Vector3(0, 500, -800),
        cameraRotation: 20,
        scale: 0.8,
        yPosition: 0
    },
    86: {
        rotationPoint: new BABYLON.Vector3(0, 0, 61.1),
        cameraPosition: new BABYLON.Vector3(0, 500, -800),
        cameraRotation: 20,
        scale: 0.2,
        yPosition: -100
    },
    96: {
        rotationPoint: new BABYLON.Vector3(0, 0, 62.76),
        cameraPosition: new BABYLON.Vector3(0, 500, -800),
        cameraRotation: 20,
        scale: 0.7,
        yPosition: 0
    },
    106: {
        rotationPoint: new BABYLON.Vector3(0, 0, 65.2),
        cameraPosition: new BABYLON.Vector3(0, 500, -800),
        cameraRotation: 20,
        scale: 1,
        yPosition: -150
    },
    116: {
        rotationPoint: new BABYLON.Vector3(0, 0, 25.5),
        cameraPosition: new BABYLON.Vector3(0, 500, -800),
        cameraRotation: 20,
        scale: 1,
        yPosition: 200
    },
    126: {
        rotationPoint: new BABYLON.Vector3(0, 0, 34.5),
        cameraPosition: new BABYLON.Vector3(0, 500, -800),
        cameraRotation: 20,
        scale: 1,
        yPosition: 0
    },
    136: {
        rotationPoint: new BABYLON.Vector3(0, 0, 56.2),
        cameraPosition: new BABYLON.Vector3(0, 500, -800),
        cameraRotation: 20,
        scale: 1,
        yPosition: 0
    },
    146: {
        rotationPoint: new BABYLON.Vector3(0, 0, 76.8),
        cameraPosition: new BABYLON.Vector3(0, 500, -800),
        cameraRotation: 20,
        scale: 1,
        yPosition: 0
    },
    156: {
        rotationPoint: new BABYLON.Vector3(0, 0, 91),
        cameraPosition: new BABYLON.Vector3(0, 500, -800),
        cameraRotation: 20,
        scale: 1,
        yPosition: 0
    },
    166: {
        rotationPoint: new BABYLON.Vector3(0, 0, 300),
        cameraPosition: new BABYLON.Vector3(0, 500, -800),
        cameraRotation: 20,
        scale: 0.8,
        yPosition: 0
    },
    176: {
        rotationPoint: new BABYLON.Vector3(0, 0, 225),
        cameraPosition: new BABYLON.Vector3(0, 500, -800),
        cameraRotation: 20,
        scale: 1,
        yPosition: -100
    },
    186: {
        rotationPoint: new BABYLON.Vector3(0, 0, 690),
        cameraPosition: new BABYLON.Vector3(0, 500, -800),
        cameraRotation: 20,
        scale: 0.3,
        yPosition: -150
    },
    196: {
        rotationPoint: new BABYLON.Vector3(0, 0, 275),
        cameraPosition: new BABYLON.Vector3(0, 500, -800),
        cameraRotation: 20,
        scale: 0.8,
        yPosition: 0
    },
    206: {
        rotationPoint: new BABYLON.Vector3(0, 0, 400),
        cameraPosition: new BABYLON.Vector3(0, 500, -800),
        cameraRotation: 20,
        scale: 0.9,
        yPosition: 0
    },
    216: {
        rotationPoint: new BABYLON.Vector3(0, 0, 370),
        cameraPosition: new BABYLON.Vector3(0, 500, -800),
        cameraRotation: 20,
        scale: 0.8,
        yPosition: 0
    },
    226: {
        rotationPoint: new BABYLON.Vector3(0, 0, 300),
        cameraPosition: new BABYLON.Vector3(0, 500, -800),
        cameraRotation: 20,
        scale: 0.9,
        yPosition: 200
    },
    236: {
        rotationPoint: new BABYLON.Vector3(0, 0, 300),
        cameraPosition: new BABYLON.Vector3(0, 500, -800),
        cameraRotation: 20,
        scale: 0.8,
        yPosition: 50
    },
    246: {
        rotationPoint: new BABYLON.Vector3(0, 0, 280),
        cameraPosition: new BABYLON.Vector3(0, 500, -800),
        cameraRotation: 20,
        scale: 0.9,
        yPosition: 20
    },
    256: {
        rotationPoint: new BABYLON.Vector3(0, 0, 200),
        cameraPosition: new BABYLON.Vector3(0, 500, -800),
        cameraRotation: 20,
        scale: 0.8,
        yPosition: 100
    }
};


// AVATARS

export const BODIES = 46;

export const faces = [
    'happy',
    'cute',
    'cuter',
    'annoyed',
    'sandbag',
    'tiny',
    'expressionless',
    'crying',
    'relieved',
    'monocle',
    '><',
    'grumpy',
    ';)',
    'OO',
    'lashes',
    'nouns',
    'hypnotized',
    'censored',
    'burglar',
    'sunglasses',
    'eyepatch',
    'stars',
    'hearts',
    'hashtag',
    '+',
    'pleased',
    'unhappy',
    'pretty',
    'cute-crying',
    'blushing',
    'pleading',
    'tall-cute',
    'little',
    'diamond',
    'sparkle',
    'angry',
    'xx',
    'scary',
    'awoken-+',
    'ancient',
    'void',
    'corpse',
    'masked',
    'matrix',
    'mime',
    'cyclops',
    'awoken-creature',
    'creature',
    'skull',
    'skull-awoken',
    'cat-eye',
    'empty',
    'chain-skull',
    '0xmon',
    'warrior-1',
    'warrior-2',
    'warrior-3',
    'elder',
];

export const avatarHexes = [
    // pink
    "#FC95FE",
    // blue
    "#0EFFFD",
    // green
    "#3Dffad",
    // lilac
    "#FF40FF",
    // yellow
    "#fff621",
    // purple
    "#9011FD",
    // bright red
    "#FF0000",
    // magenta
    "#cd01ee",
    // orange
    "#FF8200",
    // yellow-orange
    "#FFB905",
    // green
    "#2FFF00",
    // forest
    '#00bc57',
    // citrus
    '#adff00',
    // ice
    "#b2ffff",
    // dark blue
    "#0023FF",
    // true blue
    '#0090f8',
    // lavender
    "#693eff",
    // fuschia
    "#ff007a",
    // red-orange
    '#ff3d00',
    // sand
    "#AE8866",
    // rock
    "#4B2C0D",
    // white
    '#fffaf1',
    // light gray
    '#c1c1c1',
    // steel
    '#818181',
    // dark grey
    '#434343',
    // night
    '#171717'
].map(color => color.toLowerCase());;

const backgrounds = [
    // pink
    '#FFA4FF',
    // blue
    "#9efffe",
    // green
    "#b4fee8",
    // lilac
    "#feb2fe",
    // yellow
    '#fefec9',
    // purple
    "#d29ffe",
    // bright red
    "#ff9f9e",
    // magenta
    '#F79DFF',
    // orange
    "#ffb7b6",
    // yellow-orange
    "#ffe58a",
    // green
    "#c0ffb2",
    // forest
    '#a3ffcd',
    // citrus
    '#edffb9',
    // ice
    '#e5f0ff',
    // dark blue
    "#99a6ff",
    // true blue
    '#b6edff',
    // lavender
    "#cec0ff",
    // fuschia
    "#ffbadb",
    // red-orange
    '#ffbeaa',
    // sand
    "#d5c1af",
    // rock
    "#f2d4b7",
    // white
    '#434343',
    // light gray
    '#e0e0e0',
    // steel
    '#c1c1c1',
    // dark grey
    '#818181',
    // night
    '#434343'
].map(color => color.toLowerCase());

export const AVATAR_OFFSETS: { [bodyIndex: number]: number } = {
    // cylinder
    4: -0.05,
    // stacked cylinder
    5: -0.025,
    // triangle
    9: -0.1,
    // wide orb
    15: -0.05,
    // teardrop
    21: -0.225,
    // U
    23: -0.05,
    // upside down u
    24: -0.025,
    // cloud
    26: -0.05,
    // crown
    33: -0.1,
    // heart
    36: -0.05,
    // rock
    54: -0.2,
    // unihorn
    57: -0.2,
    // slime
    58: -0.2,
    // skull
    59: -0.1
};

export const avatarHexToBackground: { [avatarHex: string]: BABYLON.Color4 } = {};
avatarHexes.forEach((avatarHex, i) => {
    console.log(avatarHexes[i] + 'FF');
    avatarHexToBackground[avatarHex] = BABYLON.Color4.FromHexString((backgrounds[i] + 'FF').toLowerCase());
    console.log(avatarHexToBackground[avatarHex].toString());
});
export const avatarRGBs = avatarHexes.map(rawHex => {
    const hex = rawHex.substring(1, rawHex.length);
    const hexArray = hex.match(/.{1,2}/g);
    const rgbArray = hexArray.map(hexComponent => Math.round(parseInt(hexComponent, 16) / 255 * 1000) / 1000);
    return rgbArray.join(',');
});

export const avatarColors = avatarHexes.map(hex => BABYLON.Color3.FromHexString(hex));

// Audio

export const SOUND_DURATION = 0.0375;
export const SOUND_SMOOTHING = 0.01;
export const DIALOGUE_PITCH_DISTRIBUTION = [1.5, 1.25, 1.25, 1.125, 1.125, 1.125, 1.0625, 1.0625, 1.0625, 1.0625, 1.03125, 1.03125, 1.03125];
export const MINTING_PITCH_DISTRIBUTION = [0.5, 0.75, 0.75, 0.75, 0.75, 0.875, 0.875];


// Hyaliko Avatar Collection
export const HYALIKO_ADDRESS = '0x91a4ac1ad21fc9d3cf2d34190a1e78fd51c4712f';
export const HYALIKO_ABI = JSON.parse('[{"inputs":[{"internalType":"bytes32","name":"_airdropMerkleRoot","type":"bytes32"},{"internalType":"bytes32","name":"_whitelistMerkleRoot","type":"bytes32"},{"internalType":"string","name":"baseURI_","type":"string"},{"internalType":"address","name":"_descriptor","type":"address"}],"stateMutability":"nonpayable","type":"constructor"},{"inputs":[],"name":"ApprovalCallerNotOwnerNorApproved","type":"error"},{"inputs":[],"name":"ApprovalQueryForNonexistentToken","type":"error"},{"inputs":[],"name":"ApprovalToCurrentOwner","type":"error"},{"inputs":[],"name":"ApproveToCaller","type":"error"},{"inputs":[],"name":"BalanceQueryForZeroAddress","type":"error"},{"inputs":[],"name":"MintToZeroAddress","type":"error"},{"inputs":[],"name":"MintZeroQuantity","type":"error"},{"inputs":[],"name":"OwnerQueryForNonexistentToken","type":"error"},{"inputs":[],"name":"TransferCallerNotOwnerNorApproved","type":"error"},{"inputs":[],"name":"TransferFromIncorrectOwner","type":"error"},{"inputs":[],"name":"TransferToNonERC721ReceiverImplementer","type":"error"},{"inputs":[],"name":"TransferToZeroAddress","type":"error"},{"inputs":[],"name":"URIQueryForNonexistentToken","type":"error"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"approved","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"operator","type":"address"},{"indexed":false,"internalType":"bool","name":"approved","type":"bool"}],"name":"ApprovalForAll","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[],"name":"MAX_MINT","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"MAX_WHITELIST_MINT","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"TOKEN_LIMIT","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"airdropMerkleRoot","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"approve","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"baseURI","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"claimedAirdrop","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"claimedWhitelist","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"descriptor","outputs":[{"internalType":"contract IHyalikoDescriptor","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"getApproved","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"_tokenId","type":"uint256"}],"name":"getDna","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"getTraitsOf","outputs":[{"internalType":"bytes[6]","name":"","type":"bytes[6]"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"operator","type":"address"}],"name":"isApprovedForAll","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint16","name":"quantity","type":"uint16"},{"internalType":"bytes32[]","name":"_merkleProof","type":"bytes32[]"}],"name":"mintFromAirdrop","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"quantity","type":"uint256"}],"name":"mintFromSale","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"bytes32[]","name":"_merkleProof","type":"bytes32[]"}],"name":"mintFromWhitelist","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"mintHyalikoZero","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"ownerOf","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"publish","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"publishForAirdrop","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"publishForWhitelist","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"published","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"publishedForAirdrop","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"publishedForWhitelist","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"safeTransferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"},{"internalType":"bytes","name":"_data","type":"bytes"}],"name":"safeTransferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"operator","type":"address"},{"internalType":"bool","name":"approved","type":"bool"}],"name":"setApprovalForAll","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"baseURI_","type":"string"}],"name":"setBaseURI","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_descriptor","type":"address"}],"name":"setDescriptor","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bytes4","name":"interfaceId","type":"bytes4"}],"name":"supportsInterface","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"tokenGltfDataOf","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"tokenURI","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"tokensOfOwner","outputs":[{"internalType":"uint256[]","name":"","type":"uint256[]"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"transferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"whitelistMerkleRoot","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"withdraw","outputs":[],"stateMutability":"nonpayable","type":"function"}]');

// export const HYALIKO_DESCRIPTOR_ADDRESS = '0xd331b3ef12331b03a086a2bb675a85c76b2cff15';
// export const HYALIKO_DESCRIPTOR_ABI = JSON.parse('[{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"inputs":[],"name":"NUM_TRAITS","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"TRAIT_LENGTHS","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"bytes[]","name":"_bodies","type":"bytes[]"}],"name":"addManyBodies","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string[]","name":"_colors","type":"string[]"}],"name":"addManyColors","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bytes[]","name":"_faces","type":"bytes[]"}],"name":"addManyFaces","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bytes[]","name":"_meshes","type":"bytes[]"}],"name":"addManyMeshes","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"arePartsLocked","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"bodyData","outputs":[{"internalType":"bytes","name":"","type":"bytes"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"colorData","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"faceData","outputs":[{"internalType":"bytes","name":"","type":"bytes"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint16","name":"_dna","type":"uint16"},{"internalType":"uint8","name":"_index","type":"uint8"}],"name":"getTraitIndex","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"_dna","type":"uint256"}],"name":"getTraits","outputs":[{"internalType":"bytes[6]","name":"traits","type":"bytes[6]"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"lockParts","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"meshData","outputs":[{"internalType":"bytes","name":"","type":"bytes"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bytes[6]","name":"data","type":"bytes[6]"}],"name":"tokenGltfData","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"dna","type":"uint256"}],"name":"tokenGltfDataForDna","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"}]');

const meshData = [
    // orb
    {
        data: 'AAAAAAAAgL8AAACA5cPZPnnEWb++Np4+wFomvn3EWb9h//8+VD45P/X55L7vlQY/D8RZP6GWBr8AAACAOpYGv0/EWb8AAACAwFomvn3EWb9h//++5cPZPnnEWb++Np6+h3hzPwAAAADnNp4+u4KNvgD65L4mxFk/vpaGPr6WBr9jG08/AAAAAAAAAAD//38/Hvlkv3L55L4AAACALi0wv6aWBr+Z//8+h3hzvwAAAADnNp4+u4KNvgD65L4mxFm/Li0wv6aWBr+Z//++HnkWvwAAAAC4G0+/VD45P/X55L7vlQa/vpaGPr6WBr9jG0+/HnkWPwAAAAC4G0+/HnkWPwAAAAC4G08/HnkWvwAAAAC4G08/h3hzvwAAAADnNp6+AAAAAAAAAAD//3+/h3hzPwAAAADnNp6+u4KNPgD65D4mxFk/Li0wP6aWBj+Z//8+wFomPnzEWT9h//8+VD45v/X55D7vlQY/vpaGvr6WBj9jG08/5cPZvnnEWT++Np4+VD45v/X55D7vlQa/D8RZv6GWBj8AAACA5cPZvnnEWT++Np6+u4KNPgD65D4mxFm/vpaGvr6WBj9jG0+/wFomPnzEWT9h//++HvlkP3L55D4AAACALi0wP6aWBj+Z//++OpYGP0/EWT8AAACAAAAAAAAAgD8AAACAAAABAAIAAwABAAQAAAACAAUAAAAFAAYAAAAGAAcAAwAEAAgACQAKAAsADAANAA4ADwAQABEAEgATABQAAwAIABUACQALABYADAAOABcADwARABgAEgAUABkAGgAbABwAHQAeAB8AIAAhACIAIwAkACUAJgAnACgAKAAlACkAKAAnACUAJwAjACUAJQAiACkAJQAkACIAJAAgACIAIgAfACkAIgAhAB8AIQAdAB8AHwAcACkAHwAeABwAHgAaABwAHAAoACkAHAAbACgAGwAmACgAGQAnACYAGQAUACcAFAAjACcAGAAkACMAGAARACQAEQAgACQAFwAhACAAFwAOACEADgAdACEAFgAeAB0AFgALAB4ACwAaAB4AFQAbABoAFQAIABsACAAmABsAFAAYACMAFAATABgAEwAPABgAEQAXACAAEQAQABcAEAAMABcADgAWAB0ADgANABYADQAJABYACwAVABoACwAKABUACgADABUACAAZACYACAAEABkABAASABkABwATABIABwAGABMABgAPABMABgAQAA8ABgAFABAABQAMABAABQANAAwABQACAA0AAgAJAA0ABAAHABIABAABAAcAAQAAAAcAAgAKAAkAAgABAAoAAQADAAoA',
        componentCounts: [42, 240]
    },
    // cube
    {
        data: 'Ssc6v0rHOr9xPQq/Ssc6v0rHOj9xPQq/Ssc6P0rHOj9xPQq/Ssc6P0rHOr9xPQq/Ssc6P0rHOj9xPQo/Ssc6P0rHOr/sOws/Ssc6v0rHOj/sOws/Ssc6v0rHOr/sOws/AAABAAIAAAACAAMAAwACAAQAAwAEAAUABQAEAAYABQAGAAcAAgABAAYAAgAGAAQABwAGAAEABwABAAAAAAADAAUAAAAFAAcA',
        componentCounts: [8, 36]
    },
    // cylinder
    {
        data: 'XGe9PlbDJ79MByQ/XGe9PmYLUz9MByQ/XWe9vmYLUz9KByQ/XWe9vlbDJ79KByQ/Xmc9v2YLUz8AAICyXmc9v1bDJ78AAICyXWe9vmYLUz9LByS/XWe9vlbDJ79LByS/Wme9PmYLUz9MByS/Wme9PlbDJ79MByS/Xmc9P2YLUz8AAIAyXmc9P1bDJ78AAIAyAAABAAIAAAACAAMAAwACAAQAAwAEAAUABQAEAAYABQAGAAcABwAGAAgABwAIAAkACQAIAAoACQAKAAsABwAJAAsACwAAAAMAAwAFAAcACwADAAcACwAKAAEACwABAAAABAACAAEAAQAKAAgACAAGAAQAAQAIAAQA',
        componentCounts: [12, 60]
    },
    // torus
    {
        data: 'ZyWYv3wNxr4AAIA0EDY8vy1mgT8AAIAzc78Dv6goNT/Us12+LAFVvwmjir7Qs12+cb8Dv6coNT/as10+LQFVvwmjir7gs10+tPg7P3l8gT8AAEC0fZQDP9tHNT/gs12+fZQDP9tHNT/Qs10+IjGYPyh9xb4AAIC0mRFVPwE+ir7gs12+mBFVPwE+ir7Qs10+laMXOgAAoL8AgI4yAETUOf//X7/Xs12+AFDUOf7/X7/Xs10+AAABAAIAAAACAAMAAwACAAQAAwAEAAUABQAEAAEABQABAAAAAQAGAAcAAQAHAAIAAgAHAAgAAgAIAAQABAAIAAYABAAGAAEABgAJAAoABgAKAAcABwAKAAsABwALAAgACAALAAkACAAJAAYACQAMAA0ACQANAAoACgANAA4ACgAOAAsACwAOAAwACwAMAAkADAAAAAMADAADAA0ADQADAAUADQAFAA4ADgAFAAAADgAAAAwA',
        componentCounts: [15, 90]
    },
    // square torus
    {
        data: 'MUZiPzBGYr8AAMAzMUZiPzBGYj8AAMCzVmQeP1ZkHj/Us10+VmQeP1VkHr/Ys10+VmQeP1dkHj/Ys12+VmQeP1ZkHr/Ts12+MEZivzJGYj8AAJCzVWQev1ZkHj/Us10+VWQev1dkHj/Ys12+L0ZivzJGYr8AAJAzVGQev1dkHr/as10+VGQev1hkHr/Us12+AAABAAIAAAACAAMAAwACAAQAAwAEAAUABQAEAAEABQABAAAAAQAGAAcAAQAHAAIAAgAHAAgAAgAIAAQABAAIAAYABAAGAAEABgAJAAoABgAKAAcABwAKAAsABwALAAgACAALAAkACAAJAAYACQAAAAMACQADAAoACgADAAUACgAFAAsACwAFAAAACwAAAAkA',
        componentCounts: [12, 72]
    },
    // triangle torus
    {
        data: 'ZJCKP/z/H78AAAAyflqxu8vMnj8AAAC0fkt4u+lRXj8b8V8+Wv1BP/v/374i8V8+fkt4u+hRXj8j8V++Wv1BP/z/374d8V++B9+Jv5uZHb8AACAzCQVBv9aj3L4j8V8+CQVBv9aj3L4f8V++AAABAAIAAAACAAMAAwACAAQAAwAEAAUABQAEAAEABQABAAAAAQAGAAcAAQAHAAIAAgAHAAgAAgAIAAQABAAIAAYABAAGAAEABgAAAAMABgADAAcABwADAAUABwAFAAgACAAFAAAACAAAAAYA',
        componentCounts: [9, 54]
    },
    // pyramid
    {
        data: '4kgov+DKo74LPQo/AAAAAG+sVT8AAACA4kgov+DKo74LPQq/4kgoP+DKo74LPQq/4kgoP+DKo74LPQo/AAABAAIAAgABAAMAAwABAAQABAABAAAAAgADAAQAAgAEAAAA',
        componentCounts: [5, 18]
    },
    // eth diamond
    {
        data: 'YD6ksOBFbjwuoM6+TjRhP+BFbjys4cAyYD6ksOpCjb/wZ6Uxm7ins+BFbjwuoM4+TjRhv+BFbjwAkM8rYD6ksJxppD/wZ6UxAAABAAIAAQADAAIAAwAEAAIABAAAAAIAAAAFAAEAAQAFAAMAAwAFAAQABAAFAAAA',
        componentCounts: [6, 24]
    },
    // big star
    {
        data: 'QbqdMqAkNDvEYZ2+AACAPxAw+jvdZXw+tiwlP+5nVL45V34+Lr27s+r4gD9TXXM+mjtcPnIfJz/GkXY+njtcvrI2I7/4HIE+AAAAABEJfr8zt4I+njtcPrI2I7/4HIE+aZRiP8edYL9RMoI+tiwlP+4KZD5/dHo+aJRiP4aGZD8XZ3Q+ojtcvnIfJz/GkXY+a5Riv4aGZD8XZ3Q+tiwlv+4KZD5/dHo+AACAv5Av+jvdZXw+tiwlv+5nVL45V34+aJRiv8edYL9RMoI+AAABAAIAAAADAAQABQAGAAcABwAIAAIAAgABAAkACQAKAAQABAADAAsACwAMAA0ADQAOAA8ADwAQAAUABQAHAAIAAgAJAAQABAALAA0ADQAPAAUABQACAAQABAANAAUAAAAOAA0AAAAGAAUAAAAMAAsADAAAAA0AAwAAAAsAAAAEAAoAAQAAAAkAAAACAAgABgAAAAcADgAAAA8AAAAFABAACQAAAAoABwAAAAgADwAAABAA',
        componentCounts: [17, 90]
    },
    // little star
    {
        data: 'wPLTMLwtsTrSl5y+xVmOP/gvsToQQkA+Bz8oP6rxXr4OQkA+vnnNsxCGjj8SQkA+BVRgPp6XKD8RQkA+CVRgvm7mJ78OQkA+wPLTMHktjr8LQkA+CVRgPm7mJ78OQkA+Bz8oP2e2YT4QQkA+Bz8ov2W2YT4QQkA+xVmOv7wtsToQQkA+Bz8ov6rxXr4OQkA+DVRgvp6XKD8RQkA+AAABAAIAAAADAAQABQAGAAcAAgABAAgABQAHAAIACQAKAAsACwAFAAIAAgAIAAQABAADAAwADAAJAAsACwACAAQABAAMAAsAAAAKAAkAAAAGAAUAAAACAAcAAwAAAAwADAAAAAkAAQAAAAgAAAAFAAsABgAAAAcACgAAAAsAAAAEAAgA',
        componentCounts: [13, 66]
    },
    // teardrop
    {
        data: 'WCOrMN8VN7/cHekwWvQEP55Qrb4iMcE+2CFLvp5Qrb7/Sxw/WvQEP55Qrb4iMcG+h1ckv55Qrb6U9J8w2CFLvp5Qrb7/Sxy/+IQ2P9e5vz7cHekwrJlhPte5vz6ilS0/CKkTv9e5vz55j9Y+CKkTv9e5vz55j9a+rJlhPte5vz6ilS2/WCOrMDanzD/cHekwAAABAAIAAQAAAAMAAAACAAQAAAAEAAUAAAAFAAMAAQADAAYAAgABAAcABAACAAgABQAEAAkAAwAFAAoAAQAGAAcAAgAHAAgABAAIAAkABQAJAAoAAwAKAAYABwAGAAsACAAHAAsACQAIAAsACgAJAAsABgAKAAsA',
        componentCounts: [12, 60]
    },
    // u-beam
    {
        data: 'VOwNv1VTH78aO72+LHaEvjBEp74aO72+LHaEPjBEp74aO72+VOwNP1VTH78aO72+LHaEPt8iWz8aO72+VOwNP98iWz8aO72+VOwNv98iWz8aO70+VOwNv1VTH78aO70+LHaEvjBEp74aO70+LHaEvt8iWz8aO70+VOwNP1VTH78aO70+LHaEPjBEp74aO70+VOwNP98iWz8aO70+LHaEPt8iWz8aO70+LHaEvt8iWz8aO72+VOwNv98iWz8aO72+AAABAAIAAAACAAMAAwACAAQAAwAEAAUABgAHAAgABgAIAAkABwAKAAsABwALAAgACgAMAA0ACgANAAsAAwAFAAwAAwAMAAoADgAPAAYADgAGAAkAAgALAA0AAgANAAQADwAAAAcADwAHAAYAAQAIAAsAAQALAAIADgAJAAgADgAIAAEAAAADAAoAAAAKAAcABQAEAA0ABQANAAwADwAOAAEADwABAAAA',
        componentCounts: [16, 84]
    },
    // gem
    {
        data: 'AADAPuxoRb7Xs12+1jIYM9XzKr8AAACA1DIYM+xoRb7Xs92+AgDAPr1+kD7hRia/AABAP71+kD4AAACAAAAAP/jYAT86zZO+1DIYM/jYAT86zRO/AgAAPpJyOz/Xs12+AgCAPpJyOz8AAACAAADAPuxoRb7Xs10+AgDAPr1+kD7hRiY/AAAAP/jYAT86zZM+AgAAPpJyOz/Xs10+1DIYM+xoRb7Xs90+/v+/vr1+kD7hRiY/1DIYM/jYAT86zRM//P//vZJyOz/Xs10+AADAvuxoRb7Xs10+AABAv71+kD4AAACAAAAAv/jYAT86zZM+/v9/vpJyOz8AAACAAADAvuxoRb7Xs12+/v+/vr1+kD7hRia/AAAAv/jYAT86zZO+/P//vZJyOz/Xs12+1DIYM5JyOz8AAACAAAABAAIAAAACAAMAAAADAAQABAADAAUABQADAAYABQAGAAcABQAHAAgACQABAAAACQAAAAQACQAEAAoACgAEAAsACwAEAAUACwAFAAgACwAIAAwADQABAAkADQAJAAoADQAKAA4ADgAKAA8ADwAKAAsADwALAAwADwAMABAAEQABAA0AEQANAA4AEQAOABIAEgAOABMAEwAOAA8AEwAPABAAEwAQABQAFQABABEAFQARABIAFQASABYAFgASABcAFwASABMAFwATABQAFwAUABgAAgABABUAAgAVABYAAgAWAAMAAwAWAAYABgAWABcABgAXABgABgAYAAcABwAYABkAGQAIAAcAGQAMAAgAGQAQAAwAGQAUABAAGQAYABQA',
        componentCounts: [26, 144]
    },
    // shield
    {
        data: 'ERleQLUkA70eu3zAoutdQEXjDL2mwHzA3LhdQJ79BL3axnzA78ZdQE+67Lw+xXzAZAJeQBtv6rzyvXzAw3bCuxCchL9DmGc9w3bCuzEhjL9PlTi+d7wvP0WlO79PlTi+b5IkP01wMr8zmGc9R5wnv01wMr8zmGc9TsYyv0WlO79PlTi+8YNFP1/JWr4zmGc91+RSP+tXXr5PlTi+1+RSP+U5bj9XlTi+8YNFPzecXD8dmGc9r+5Vv+tXXr5PlTi+r+5Vv+U5bj9XlTi+yY1Iv1/JWr4zmGc9yY1IvzecXD8dmGc9CxI2v/9WRz+HxJQ8KggzP/9WRz+HxJQ8MK0Yv/eAJL+pxJQ8w3bCu2tfcb+pxJQ8CxI2vxEaUr6HxJQ8WKMVP/eAJL+pxJQ8KggzPxEaUr6HxJQ8AAABAAIAAgADAAQAAgAEAAAABQAGAAcABQAHAAgACQAKAAYACQAGAAUACwAMAA0ACwANAA4ADQAMAAcABwAGAAoACgAPABAAEAANAAcABwAKABAADwAKAAkADwAJABEADgASABMADgATABQAFQAJAAUAFQAFABYAFwARAAkAFwAJABUAGAAIAAsAGAALABkACAAHAAwACAAMAAsADgAUABkADgAZAAsAEwASABEAEwARABcAFgAFAAgAFgAIABgADgANABAADgAQABIAEAAPABEAEAARABIAFgAYABkAGQAUABMAEwAXABUAFQAWABkAGQATABUAAAA=',
        componentCounts: [26, 123]
    },
    // crown
    {
        data: 'VqA8P6BsCT8o3lozVaA8P9p2hT+Sztk+VaA8Pxsr876Sztk+VqA8Pxsr876Pztm+VqA8P9p2hT+Pztm+VKC8PqBsCT/sWiM/Cdqhs9p2hT+Qzlk/Cdqhsxsr876Qzlk//KyiPqBsCT+c4Qy/SOhQMdp2hT981zu/SOhQMRsr87581zu//KwiPxsr875617u+/KwiP9p2hT9617u+VqA8v6BsCT84zIcvVqA8v9p2hT+Nztm+VqA8vxsr876Nztm+VqA8vxsr876Nztk+VqA8v9p2hT+Nztk+VqC8vqBsCT/rWiO/MMyHsNp2hT+Qzlm/MMyHsBsr876Qzlm/VqC8PqBsCT/sWiO/+6wiP6BsCT/B7dsy+qwiP9p2hT9917s+r+aHsxsr87571zs/+qwiPxsr875917s++6wivxsr875417s++qyiPqBsCT+c4Qw/r+aHs9p2hT971zs//KyivqBsCT+c4Qw/+6wiv9p2hT9417s+VqC8vqBsCT/sWiM//Kwiv6BsCT84zIcv/Kwiv9p2hT9417u+/KyivqBsCT+c4Qy//Kwivxsr875417u+AAABAAIAAgADAAQAAAACAAQABQAGAAcABwACAAEABQAHAAEACAAJAAoACgALAAwACAAKAAwADQAOAA8ADwAQABEADQAPABEAEgATABQAFAAPAA4AEgAUAA4AFQAEAAMAAwAUABMAFQADABMACAAMAAQACAAEABUAFgAXAAEAFgABAAAAGAAZAAIABwAQABoAGAACAAcABwAaABgAGwAcAAYAGwAGAAUAHQAeABEAHQARAB8AIAAhAA4AIAAOAA0AIgAJABMAIgATABIAHAAdAB8AHAAfAAYAFwAbAAUAFwAFAAEADAAWAAAADAAAAAQACQAIABUACQAVABMAIQAiABIAIQASAA4AHgAgAA0AHgANABEAHgAaACMAIwAhACAAIwAgAB4AIgAhACMAIwAKAAkAIgAjAAkAHQAcABgAGAAaAB4AHQAYAB4AFgAMAAsACwAZABcAFgALABcAGwAXABkAGQAYABwAGwAZABwAHwARABAAEAAHAAYAHwAQAAYAIwAaABAAAwACABkAAwAZAAsAIwAQAA8AAwALAAoACgAjAA8AFAADAAoADwAUAAoA',
        componentCounts: [36, 216]
    },
    // honeycomb
    {
        data: 'AAAAAOYlfr/IzMw+AAAAAOYlfr/QzMy+2LNdP+Il/r7OzMy+2LNdP+Yl/r7NzMw+17NdP+wl/j7MzMy+17NdP+gl/j7OzMw+Lr27s+glfj/IzMy+Lr27s+glfj/QzMw+2LNdv+Yl/j7LzMy+2LNdv+Il/j7OzMw+C3Acv/RUsz7OzMw+DHAcv/RUs77MzMw+DHAcv/JUs77OzMy+C3Acv/RUsz7MzMy+2LNdv94l/r7OzMy+2LNdv+Ql/r7LzMw+w/J0s/RUMz/PzMw+w/J0s/ZUMz/MzMy+IQouMvZUM7/KzMw+DHAcP/ZUs77MzMw+CnAcP/hUsz7OzMw+IQouMvRUM7/PzMy+DHAcP/RUs77OzMy+CnAcP/hUsz7MzMy+AAABAAIAAAACAAMAAwACAAQAAwAEAAUABQAEAAYABQAGAAcABwAGAAgABwAIAAkACgALAAwACgAMAA0ACQAIAA4ACQAOAA8ADwAOAAEADwABAAAAEAAKAA0AEAANABEACwAKAAkADwAAABIACwAJAA8ACwAPABIABgARAA0ADQAMAA4ACAAGAA0ADQAOAAgAEwASAAAAAwAFABQAEwAAAAMAEwADABQAFQAWAAIAAQAOAAwAFQACAAEAFQABAAwAAgAWABcAFwARAAYABAACABcAFwAGAAQACwASABUACwAVAAwAEgATABYAEgAWABUAEwAUABcAEwAXABYAFAAQABEAFAARABcAEAAUAAUABwAJAAoAEAAFAAcAEAAHAAoA',
        componentCounts: [24, 144]
    },
    // heart
    {
        data: 'deR1vhBdWD+DaDi+feR1vhBdWD/YKzk+KGb4MyYwHT/cKzk+0E47NCYwHT+GaDi+55pMPyjrnL1+aDi+55pMPxjrnL3cKzk+gETos6AfSr/gKzk+gETos6AfSr+CaDi+kuR1Pg1dWD/YKzk+h+R1Pg1dWD+DaDi+6ppMv8DqnL3cKzk+6ppMv8DqnL1+aDi+00ywM/EPyT4aQ50+sQWevsqWMD8WQ50+0XISv6QxMj8WQ50+oOc3v4wfFj8WQ50+AhFDvyuErz4WQ50+iTQov9wAIzwYQ50+TMh4szR+E78cQ50+hzQoP9z+IjwYQ50+BRFDPxiErz4WQ50+ouc3P4QfFj8WQ50+2HISP58xMj8WQ50+twWePsqWMD8WQ50+yy0gv2q2Wj+CaDi+zi0gv2q2Wj/YKzk+fApev/hZLD+CaDi+fApev/pZLD/YKzk+MaRtv99eqj6AaDi+MaRtv+Feqj7YKzk+NKRtP8Zeqj6AaDi+NKRtP8teqj7YKzk+gwpeP/BZLD+CaDi+gwpeP/BZLD/YKzk+0S0gP2K2Wj+CaDi+0i0gP2K2Wj/YKzk+hzQoP1z+Ijxp4Zy+TMh4szR+E79n4Zy+iTQov9wAIzxp4Zy+AhFDvyiErz5p4Zy+oOc3v4ofFj9q4Zy+0XISv6IxMj9q4Zy+rgWevsqWMD9q4Zy+6DI2NO0PyT5r4Zy+sgWePsSWMD9q4Zy+03ISP54xMj9q4Zy+o+c3P4IfFj9q4Zy+BRFDPxGErz5p4Zy+AAABAAIAAAACAAMABAAFAAYABAAGAAcAAwACAAgAAwAIAAkABwAGAAoABwAKAAsADAANAA4ADgAPABAAEAARABIAEgATABQAFAAVABYAFgAXAAwADAAOABAAEAASABQAFAAWAAwAEAAUAAwAAQAAABgAAQAYABkAGQAYABoAGQAaABsAGwAaABwAGwAcAB0AHQAcAAsAHQALAAoABQAEAB4ABQAeAB8AHwAeACAAHwAgACEAIQAgACIAIQAiACMAIwAiAAkAIwAJAAgAJAAlACYAJgAnACgAKAApACoAKwAsAC0AKAAqACsAJAAmACgALgAvACQAKwAtAC4AJAAoACsAKwAuACQADgANAAEADgABABkAKgApABgAKgAYAAAADwAOABkADwAZABsAKQAoABoAKQAaABgAEAAPABsAEAAbAB0AKAAnABwAKAAcABoAEQAQAB0AEQAdAAoAJwAmAAsAJwALABwAFAATAAUAFAAFAB8AJAAvAB4AJAAeAAQAFQAUAB8AFQAfACEALwAuACAALwAgAB4AFgAVACEAFgAhACMALgAtACIALgAiACAAFwAWACMAFwAjAAgALQAsAAkALQAJACIAJQAkAAQAJQAEAAcAJgAlAAcAJgAHAAsAKwAqAAAAKwAAAAMALAArAAMALAADAAkAEgARAAoAEgAKAAYADQAMAAIADQACAAEAEwASAAYAEwAGAAUADAAXAAgADAAIAAIA',
        componentCounts: [48, 276]
    },
    // gear
    {
        data: '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',
        componentCounts: [80, 480]
    },
    // hexagon torus
    {
        data: 'EkdtP55437HY4hcyD0ftPgx9TT8AAAA0JRimPojXDz8IZCQ+JhgmPwAAALIKZCQ+JRimPofXDz8IZCS+JhgmPwAAAAAJZCS+DUftvgx9TT8AAAAzIhimvonXDz8IZCQ+IhimvonXDz8IZCS+EEdtv7kKoDPQ4hcyJRgmvwAAgDMJZCQ+JRgmvwAAkDMJZCS+DUftvg19Tb8AAACzIhimvonXD78IZCQ+IhimvorXD78MZCS+D0ftPgx9Tb8AAAC0JRimPojXD78IZCQ+JRimPojXD78IZCS+AAABAAIAAAACAAMAAwACAAQAAwAEAAUABQAEAAEABQABAAAAAQAGAAcAAQAHAAIAAgAHAAgAAgAIAAQABAAIAAYABAAGAAEABgAJAAoABgAKAAcABwAKAAsABwALAAgACAALAAkACAAJAAYACQAMAA0ACQANAAoACgANAA4ACgAOAAsACwAOAAwACwAMAAkADAAPABAADAAQAA0ADQAQABEADQARAA4ADgARAA8ADgAPAAwADwAAAAMADwADABAAEAADAAUAEAAFABEAEQAFAAAAEQAAAA8A',
        componentCounts: [18, 108]
    },
    // v
    {
        data: '7Y+UNOLXdj+mxMG+s7EoP8W4D7+oxMG+Em2ms9yxnr6oxMG+t7Eov8W4D7+oxMG+7Y+UNOLXdj+oxME+trEov8W4D7+oxME+EW2ms9yxnr6oxME+sLEoP8W4D7+oxME+AAABAAIAAAACAAMABAAFAAYABAAGAAcAAAAEAAcAAAAHAAEAAwAFAAQAAwAEAAAAAgAGAAUAAgAFAAMAAQAHAAYAAQAGAAIA',
        componentCounts: [8, 36]
    },
    // i
    {
        data: 'sSQuvzI2ub5iQpI+sSQuPzI2ub5iQpI+sSQuPys2Dr5iQpI+cuiyPtgxlzxiQpI+cuiyvtgxlzxiQpI+sSQuvys2Dr5iQpI+sSQuv06JOz9iQpI+sSQuv8B7Aj9iQpI+cuiyvlBptD5iQpI+sSQuP06JOz9iQpI+cuiyPlBptD5iQpI+sSQuP8B7Aj9iQpI+sSQuP06JOz9iQpK+sSQuv06JOz9iQpK+sSQuvzI2ub5iQpK+sSQuPzI2ub5iQpK+sSQuP8B7Aj9iQpK+cuiyPlBptD5iQpK+cuiyPtgxlzxiQpK+sSQuPys2Dr5iQpK+sSQuvys2Dr5iQpK+cuiyvtgxlzxiQpK+cuiyvlBptD5iQpK+sSQuv8B7Aj9iQpK+AAABAAIAAAACAAMABAAFAAAABgAHAAgABAAAAAMACQAGAAgACAAEAAMACgALAAkACAADAAoACgAJAAgABgAJAAwABgAMAA0AAQAAAA4AAQAOAA8ACQALABAACQAQAAwACwAKABEACwARABAACgADABIACgASABEAAwACABMAAwATABIAAgABAA8AAgAPABMAAAAFABQAAAAUAA4ABQAEABUABQAVABQABAAIABYABAAWABUACAAHABcACAAXABYABwAGAA0ABwANABcAFwANAAwADAAQABEAEgATAA8AFwAMABEAEgAPAA4AFgAXABEADgAUABUAFQAWABEAEQASAA4AEQAOABUA',
        componentCounts: [24, 132]
    },
    // coffee
    {
        data: '8ODgPYm6Fr/Dgq8+wj9iPjpeh74UQS8/NRNpvkZeh74Roy4/XJ3tvX26Fr+k464+DSAXvzpeh75k5dU+kuaYvn26Fr+hd1U+1ok6vzpeh76okfq76468vn26Fr85HLu7evsWvzpeh76R9ty+osGYvn26Fr9yZGC+1iZovjpeh778KzG/8q7svX26Fr+5WLO+eixjPkZeh74BjjC/VM/hPX26Fr+cubK+TKYVP0Zeh75ju9m+CPOVPn26Fr9KI12+RM6VPn26Fr+cuFg+ZJu5Pom6Fr8Gh+m6hLo/P1YMyz2QVws/U1SRPmAMyz0FxmA/w4EVP0Zeh77QINk+3EZtP1YMyz2s/aM6JxA5P0Zeh77Q2iM5Uuk/P1YMyz2gMAu/sDUwP0Jeh77xfdm9w4AeP0Jeh75sR6O+2+uRPloMyz2D5mG/0keUvmIMyz3ysGK/OTRBv2YMyz2LQg2/mMBuv2YMyz35Pg+8F2NBv2IMyz2mRQk/Rd+Uvl4Myz2b+18/DtdWP4jMuz4cRMC+kIpVP5ZliD5XDr++otl+v9y2FD+HyhS8pjhOv9y2FD+2vxa/qzWevty2FD9L9XG/8+ObPty2FD9AHXG/tYdmP4jMuz5chz++3l99P9y2FD8yWdA6JkKbPty2FD9tCnA/edeevty2FD9HMm8/YyhlP9y2FD/QIZS+6PBMP9y2FD/8iRS/5b5MP9y2FD/V1BQ/mGpOv9y2FD/8nhI/Eh5lP5ZliD53gT6+SK12P0hjiD6tOcy+W6SBP95niD4NPHS+rq+JP+bLuz4i59i+CMyPP+bLuz7hPYa+hoGMP2Azvr4MXoi+lOGFP3Qzvr6ADtq+Ys2BP0heh74Fp3S+O1t2Pzxeh74wBMy+sdoRP24zvr5iQ9i9hqQFP2Yzvr5cLIG+AAABAAIAAAACAAMAAwACAAQAAwAEAAUABQAEAAYABQAGAAcABwAGAAgABwAIAAkACQAIAAoACQAKAAsACwAKAAwACwAMAA0ADQAMAA4ADQAOAA8AEAAAAAMAAwAFAAcABwAJAAsACwANAA8ADwARABAAEAADAAcABwALAA8ABwAPABAAEgATAAEAEgABABQAFQASABQAFQAUABYADgAXABUAFQAWABgAGQAOABUAFQAYABkAGgAXAA4AGgAOAAwAGwAaAAwAGwAMAAoAHAAbAAoAHAAKAAgAHQAcAAgAHQAIAAYAHgAdAAYAHgAGAAQAHwAeAAQAHwAEAAIAAQATAB8AAQAfAAIAEAAUAAEAEAABAAAAIAAhABcAIgAjABwAIgAcAB0AIwAkABsAIwAbABwAJAAlABoAJAAaABsAJgAnABUAKAApAB8AKAAfABMAJgAqACcAJQArABcAJQAXABoALAAoABMALAATABIAJwAsABIAJwASABUALQAiAB0ALQAdAB4AFwAhAC4AFwAuABUAKQAtAB4AKQAeAB8ALgAhAC8ALgAvADAAIQAgADEAIAAmADIAIAAyADEALgAwADIAMQAyADMAMQAzADQAMAA1ADMAMAAvADYAMAA2ADUALwAxADQANQAYADcANQA2ABkANQAZABgANgA0ADgANAAzADcANAA3ADgAGQA4AA8AGQAPAA4ALQApACgAKAAsACcAJwAqACsAKwAlACQAJAAjACIAIgAtACgAKAAnACsAKwAkACIAKAArACIAEQAWABQAEQAUABAADwA4ADcADwA3ABEANwAYABYANwAWABEAIAArACoAJgAgACoALwAhADEAJgAuADIANgAvADQAMgAwADMAMwA1ADcAGQA2ADgALgAmABUAKwAgABcA',
        componentCounts: [57, 342]
    },
    // flower
    {
        data: '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',
        componentCounts: [84, 492]
    },
    // ghost
    {
        data: 'DPk8v9snyj6tfrmzf45Sv94vIL54dDy0f47SvuYvIL7rWDY/EPm8vtUnyj7ApyM/3vPPvbAEdj+ZFzQ+zPPPPbAEdj+aFzQ+1PNPPrAEdj/bVcUzz/PPPbAEdj+QFzS+4fPPvbAEdj+OFzS+3PNPvrAEdj/scj0xCPm8PtQnyj7ApyM/f47SPuIvIL7tWDY/fI5SP9ovIL5zQUszC/k8P9wnyj5Ke5Uzf47SPt4vIL7tWDa/C/m8Ptknyj6/pyO/go7SvtovIL7tWDa/Efm8vt0nyj6/pyO/TBT3vuDIXD/scj0xUxR3vuDIXD8Z+tU+UhR3vuDIXD8U+tW+t7LlPiE/Qr+m7Ea/t7JlPyE/Qr/scj0xCEYsP7sqbb+n7Ma+RxR3PuDIXD8W+tW+t7LlviU/Qr+j7EY/lgvGs70qbb+j7EY/tLLlPiE/Qr+j7EY/SxT3PtzIXD9zQUszRRR3PtzIXD8c+tU+C0YsP7sqbb+m7MY+t7LlviE/Qr+k7Ea/5KxMs7sqbb+m7Ea/uLJlvyE/Qr94dDy0CUYsv70qbb+n7Ma+C0Ysv70qbb+e7MY+AAABAAIAAAACAAMABAAFAAYABgAHAAgACAAJAAQABgAIAAQACgALAAwACgAMAA0ADQAMAA4ADQAOAA8ADwAOABAADwAQABEAEQAQAAEAEQABAAAAAwACAAsAAwALAAoACQASABMACQATAAQACAAUABIACAASAAkAFQAWABcABwAYABQABwAUAAgAGQAaABsABgAcABgABgAYAAcABQAdABwABQAcAAYABQAEABMABQATAB0AFgAbAB4AHwAVACAAEwADAAoAEwAKAB0AFAARAAAAFAAAABIAGAAPABEAGAARABQAHAANAA8AHAAPABgAHQAKAA0AHQANABwAEgAAAAMAEgADABMAIQAfACIAIQAjABkAEAAOABUAEAAVAB8ADgAMABYADgAWABUADAALABsADAAbABYAAgAZABsAAgAbAAsAAQAhABkAAQAZAAIAAQAQAB8AAQAfACEA',
        componentCounts: [36, 174]
    },
    // little sphere
    {
        data: 'F3xvMkhLXT8cA1oxKs0fP05b2j7Yr08+FYbFPk5b2j6K7we/F4bFvk5b2j6H7we/9uRwM05b2j7gBig/Ks0fv05b2j7er08+AACAs6Z1kL42aDW/0YYsP6Z1kL62OWC+vEDVPqZ1kL6owhI/ukDVvqZ1kL6rwhI/0YYsv6Z1kL6wOWC+F3xvMnJYOL8cA1oxAAABAAIAAgADAAAAAAAEAAEAAAAFAAQAAAADAAUAAgAGAAMAAQAHAAIABAAIAAEABQAJAAQAAwAKAAUAAgAHAAYAAQAIAAcABAAJAAgABQAKAAkAAwAGAAoABwALAAYACAALAAcACQALAAgACgALAAkABgALAAoA',
        componentCounts: [12, 60]
    },
    // shroom
    {
        data: 'PVChPjnK4D5QCd0+JwkCP7fK4D63Oyq+8A42My0nIz8GFYY03l6gvj/K4D7IuN0+1jYCvz3K4D7OACi+pM+VujvK4D7e0Qi/xfoGPwhJkjwg9Dg/T51ZPwhJkjxLcY6+xDAGvwhJkjzyhjk/JupZvwhJkjwZlIy+AOv6ughJkjww+GS/dDbnPSYj9zypZh4+s9vlvYYi9zyy5B4+F9xlvmRNDr+75J4+ETZnPlpNDr+xZp4+KKI6vmYi9zyMyXC9ANHUuSYj9zyzGUS+ADRVulpNDr+rGcS+WqK6vmZNDr9tyfC9gmE6PqYo9zzR/nO9UWG6PgJNDr+y/vO99zz5PmynYL2ywSo/KulIP1WqYL1IgoO+r8f3vpyqYL01SSs//C9Jv5yqYL2cyYG+AHTnumynYL3mZFO/NZC7tRKrAr9KpEM1AAABAAIAAwAAAAIABAADAAIABQAEAAIAAQAFAAIAAQAAAAYAAQAGAAcAAAADAAgAAAAIAAYAAwAEAAkAAwAJAAgABAAFAAoABAAKAAkABQABAAcABQAHAAoACwAMAA0ACwANAA4ADwAQABEADwARABIAEwALAA4AEwAOABQADAAPABIADAASAA0AEAATABQAEAAUABEABwAGABUABwAVABYABgAIABcABgAXABUACAAJABgACAAYABcACQAKABkACQAZABgACgAHABYACgAWABkACwATABYACwAWABUADAALABUADAAVABcADwAMABcADwAXABgAEAAPABgAEAAYABkAEwAQABkAEwAZABYADgAaABQADQAaAA4AEgAaAA0AEQAaABIAFAAaABEA',
        componentCounts: [27, 150]
    },
    // stone
    {
        data: 'S2AxPxwDpr6x3dW+F0AfPxwDpr6DWaY+/CzcvhwDpr66g70+xk1vvxwDpr55W7i9Cy6pvhwDpr4C1TC/hAlcP/yV/j2YTl89fVBGPw2nEj+6C12+vNc4PrCxRD8xCNw+aF9JPXKfhb7SCNw+LRMAP2LSf77SCNw+ZDAtP3M7rr3SCNw+ibwUP/+jqz7SCNw+2mgBv1DPZr7SCNw+UHwkv0NHsr3SCNw+sdkiv0EMuT7SCNw+aZRcvw2nEj92FuW+kv6mPg2nEj+i/gO/3ogUP6o+Vj9XRQ6++ZM4vqOCbT+o122+AAABAAIAAgADAAQAAgAEAAAAAQAAAAUAAAAGAAUABwAIAAkACQAKAAsACQALAAcAAwAMAA0AAwANAA4ABAADAA8AAAAEABAABgAHAAsADAAIAAcABwAOAA0ABwANAAwAAwAOAA8ABAAPABAAAAAQAAYABwAGABEADgAHABIADwAOABIAEAAPABIAEAARAAYAEgAHABEABQAGAAsAAQAIAAIAAgAIAAwAEAASABEAAwACAAwACQABAAoACwAKAAUAAQAJAAgACgABAAUA',
        componentCounts: [19, 102]
    },
    // sword
    {
        data: 'g9ODvZRejL8j4zC9g9ODPZRejL8j4zC9g9ODPZRejL8CDCc9g9ODvZRejL8CDCc9Rnj6PQx1bb+b6KA9Rnj6vQx1bb+b6KA9Rnj6PQx1bb8r1KW9Rnj6vQx1bb8r1KW93VPyvjoOB7/Jgak93VPyvg7Dxr7Jgak93VPyvg7Dxr5Zba693VPyvjoOB79Zba69KtKeMXbyEr8ziRC+KtKeMZr6rr4ziRC+3VPyPg7Dxr5Zba693VPyPjoOB79Zba693VPyPg7Dxr7Jgak93VPyPjoOB7/Jgak9KtKeMXbyEr9qEw4+KtKeMZr6rr5qEw4+8VKoMSUckz8Hcp26npe6vhSoTz8Hcp26HKGpvnKfQT/n0k098VKoMYooiD8PmZs98VKoMYooiD+bhKC9HKGpvnKfQT8Hqle9HKGpPnKfQT8Hqle9npe6PhSoTz8Hcp26HKGpPnKfQT/n0k09Zu6JvoZCur5+SDC98VKoMZr6rr5jBYO98VKoMZr6rr6kM3w9Zu6JvoZCur5acSY9BUaZvsKDu74Hcp26Zu6JPoZCur5acSY9Zu6JPoZCur5+SDC9BUaZPsKDu74Hcp26Spr1vR/vD7/ru509Spr1PR/vD7/ru509KtKeMXbyEr9i5Zw9Spr1PR/vD797p6K9Spr1vR/vD797p6K9KtKeMXbyEr/z0KG9oYyLvQx1bb9I9jq9oYyLPQx1bb9I9jq9oYyLPQx1bb8nHzE9oYyLvQx1bb8nHzE9AAABAAIAAAACAAMAAwACAAQAAwAEAAUAAQAGAAQAAQAEAAIABwAAAAMABwADAAUABwAGAAEABwABAAAACAAJAAoACAAKAAsADAANAA4ADAAOAA8ADwAOABAADwAQABEAEgATAAkAEgAJAAgAEQAQABMAEQATABIACwAKAA0ACwANAAwAFAAVABYAFAAWABcAGAAZABUAGAAVABQAGgAYABQAGgAUABsAGwAUABcAGwAXABwAHQAeAA0ACQATAB8ACQAfACAAHQANAAoACQAgACEAIQAdAAoACgAJACEAIgAfABMADgANAB4ADgAeACMAIgATABAADgAjACQAJAAiABAAEAAOACQAIQAVABkAIQAZAB0AGgAjAB4AGgAeABgAJAAbABwAJAAcACIAHwAXABYAHwAWACAAIwAaABsAIwAbACQAFgAVACEAFgAhACAAIgAcABcAIgAXAB8AGQAYAB4AGQAeAB0AJQAmACcAKAApACoAKgAMAA8ADwARABIAEgAnACYAKAAqAA8ADwASACYADwAmACgAJQAnABIAEgAIAAsACwAMACoACwAqACkAJQASAAsACwApACUAKwAHAAUABAAGACwABAAsAC0ALgArAAUABAAtAC4ABQAEAC4ALAAGAAcALAAHACsAKQAoACwAKQAsACsAJQApACsAJQArAC4ALAAoACYALAAmAC0AJgAlAC4AJgAuAC0A',
        componentCounts: [47, 270]
    },
    // tv
    {
        data: 'YEpXv2BKV798j+0+YEpXv2BKVz98j+0+MI4GvzCOBj8xHA6/MI4GvzCOBr8xHA6/MI4GPzCOBj8xHA6/MI4GPzCOBr8xHA6/YEpXP2BKVz98j+0+YEpXP2BKV798j+0+aFwzv2hcMz+K9LY+aFwzv2hcM7+K9LY+aFwzv2hcM7/Ow4s+aFwzv2hcMz/Ow4s+aFwzP2hcMz+K9LY+aFwzP2hcM7+K9LY+aFwzP2hcM7/Ow4s+aFwzP2hcMz/Ow4s+AAABAAIAAAACAAMAAwACAAQAAwAEAAUABQAEAAYABQAGAAcACAAJAAoACAAKAAsAAwAFAAcAAwAHAAAABAACAAEABAABAAYACQAIAAEACQABAAAADAANAAcADAAHAAYADQAJAAAADQAAAAcACAAMAAYACAAGAAEADgAPAAsADgALAAoADAAIAAsADAALAA8ADQAMAA8ADQAPAA4ACQANAA4ACQAOAAoA',
        componentCounts: [16, 84]
    },
    // unihorn
    {
        data: 'SKicM34YZr8wi3E8Qnr5vs7fxb6E6Se/Tnn5Ps7fxb7M6Se/mtRJv87fxb4BtIo+EtVJP87fxb7ytIo+rpOIts7fxb6e/Vc/EdVJv/SQ4j5+OHe+7niNNvSQ4j5CcVC/mtRJP/SQ4j6cNne+SXr5PvSQ4j7adS8/SHn5vvSQ4j4kdi8/itq1NeT8RD9UyIM++SlkvosCCT8cZxA/akGCNl9jnD8mPkY/SKicMxNxdD8wi3E8kitkPowCCT/2ZhA/AAABAAIAAQAAAAMAAAACAAQAAAAEAAUAAAAFAAMAAQADAAYAAgABAAcABAACAAgABQAEAAkAAwAFAAoAAQAGAAcAAgAHAAgABAAIAAkABQAJAAoAAwAKAAYACwAMAA0ABwAGAA4ADwAMAAoADwAKAAkACQAIAA4ACwAPAAkACwAJAA4ADAALAA4ADAAOAAoACAAHAA4ADwALAA0ADAAPAA0ABgAKAA4A',
        componentCounts: [16, 84]
    },
    {
        data: 'rCIpOvRCCb9gfZa5hjcNP5p81L51Vb4+l9dWvpp81L6tBxo/hjcNP5p81L6zoL6+bi8uv5p81L7gfZa5l9dWvpp81L5NLRq/jlppP03W8b3cToY+jlppP1PW8b0bmoa+UKxdP6nBjj6IfZa5mFBbPE3W8b3HtEg/QwUNP1PW8b27Qjk/2TmJPqnBjj4KtkM/6wFnv03W8b3y1pE+v/cRv1PW8b11sjU/kgkzv6nBjj6k2vE+v/cRv03W8b0V2DW/6wFnv1PW8b0xIpK+kgkzv6nBjj7gJfK+QwUNP03W8b1aaDm/mFBbPFPW8b0Z9WK/2TmJPqnBjj6p20O/CJnoPfAQHz8n6s8+ts7cPvAQHz+IfZa5azJ1PhMrij9gfZa5wwfNvvAQHz/scIA+wwfNvvAQHz8rvIC+CJnoPfAQHz9lNdC+AAABAAIAAQAAAAMAAAACAAQAAAAEAAUAAAAFAAMABgAHAAgACQAKAAsADAANAA4ADwAQABEAEgATABQABgAIAAsABgALAAoACwAOAA0ADAAOABEADAARABAADwARABQADwAUABMAEgAUAAgAEgAIAAcAFQAWABcAGAAVABcAGQAYABcAGgAZABcAFgAaABcACAAUABoACAAaABYAFAARABkAFAAZABoAEQAOABgAEQAYABkADgALABUADgAVABgACwAIABYACwAWABUAAwASAAcABQAPABMABAAMABAAAgAJAA0AAQAGAAoAAwAFABMAAwATABIABQAEABAABQAQAA8ABAACAA0ABAANAAwAAgABAAoAAgAKAAkAAQADAAcAAQAHAAYACQALAA0A',
        componentCounts: [27, 150]
    },
    // skull
    {
        data: 'JgTXPnjAmz+NH8W+B+GFPrHpiD9ViQU+bjMpP9mnVD/UiK484UqLMSudAD/2tk4+bqUcPhJ6QD4aCWk+bjMpP7P6Ej8IIBA+4UqLMbvkE727nZU+K1AePi8Cq767nZU+qQhEPlBQ4b515oU+V1+qPmxcwjyzz0U+bjMpP3jNPj5SjJY9hHniPgvUgL60vdU9bjMpP1s2ej+NH8W+oi1EPzhP+j6PH8W+NdYQP5Y6Dr7aAqC93/EyPxRYm72SH8W+JgTXvnjAmz+NH8W+bjMpv9mnVD/UiK48B+GFvrHpiD9ViQU+bjMpv7P6Ej8IIBA+b6UcvhJ6QD4aCWk+qQhEvlBQ4b515oU+KVAevi8Cq767nZU+OMNxMp9nkL7GM5c+bjMpv3jNPj5SjJY9V1+qvmxcwjyzz0U+hHnivgvUgL60vdU9bjMpv1s2ej+NH8W+oC1EvzhP+j6PH8W+NdYQv5Y6Dr7aAqC93/EyvxRYm72SH8W+4UqLMXSwjD82wCk+uOX+Lx7cqT+LH8W+08qMPukQJr/F+kE+Ku4iMi+3N7/Njn8+Ku4iMnOsUL+wwFU+Fh2hPrVYT789Wgo+0Ab+Po/d1b4xGlm93Xj6PrHyD7+q5zm+9WmmMdsNA78sZH8+08qMvukQJr/F+kE+Fh2hvrVYT789Wgo+0wb+vo/d1b4xGlm94Hj6vrHyD7+q5zm+PKIcMmjDSb67nZU+AAABAAIAAwAEAAUABAAGAAcABAAHAAgABAAJAAoACwAJAAgADAACAA0ACAAJAAQABAAKAAUADgAPAA0ADgANAAoAAQAFAAIAEAARABIAAwATABQAFAAVABYAFAAWAAYAFgAVABcAFAAYABkAGgAVABkAGwAcABEAFwAIAAcAFQAUABkAFAATABgAHQAcAB4AHQAYABwAEgARABMAAAACAAwABgAEABQAAwAFAAEAAwABAB8AIAAfAAEAIAABAAAAFAAEAAMACgAJAAsACgALAA4AAgAFAA0ADQAFAAoAEAAbABEAAwAfABIAAwASABMAIAAQABIAIAASAB8AGAAdABoAGAAaABkAEQAcABMAHgAcAA0AHgANAA8ADQAcABsADQAbAAwADAAbABAADAAQAAAAAAAQACAAHAAYABMADgAdAB4ADgAeAA8AIQAiACMAIQAjACQAJQAhACQAJQAkACYAJQAmAA8AJQAPAA4ADgAhACUAIQAnACIAKAApACMAKAAjACIAKgArACkAKgApACgAKgAdAB4AKgAeACsAHQAqACgAKAAiACcAJgArAB4AJgAeAA8ALAAWABcALAAXAAcAJAAjACkAJgAkACkAJgApACsA',
        componentCounts: [45, 234]
    }
];

export const meshBytes = meshData.map((mesh) => {
    const vectorCountBuffer = Buffer.alloc(2);
    vectorCountBuffer.writeInt16BE(mesh.componentCounts[0], 0);
    const scalarCountBuffer = Buffer.alloc(2);
    scalarCountBuffer.writeInt16BE(mesh.componentCounts[1], 0);
    const meshBuffer = Buffer.from(mesh.data, 'base64');
    return Buffer.concat([vectorCountBuffer, scalarCountBuffer, meshBuffer]);
});

const bodyData = [
    // orb
    { meshIndex: 0, faceZ: '1.00', numMeshTransformations: 0, meshTransformations: null },
    // cube
    { meshIndex: 1, faceZ: '0.58', numMeshTransformations: 0, meshTransformations: null },
    // diamond
    {
        meshIndex: 1,
        faceZ: '0.58',
        numMeshTransformations: 1,
        meshTransformations: [
            [
                '0.00, 0.00, 0.00',
                '0.924, 0.383, 0.000, 0.000',
                '1.00, 1.00, 1.00'
            ]
        ]
    },
    // cube stack
    {
        meshIndex: 1,
        faceZ: '0.58',
        numMeshTransformations: 3,
        meshTransformations: [
            [
                '0.00,-0.40, 0.00',
                '0.000, 0.000, 0.000, 0.000',
                '0.80, 0.20, 0.80'
            ],
            [
                '0.00, 0.00, 0.00',
                '0.000, 0.000, 0.000, 0.000',
                '0.80, 0.20, 0.80'
            ],
            [
                '0.00, 0.40, 0.00',
                '0.000, 0.000, 0.000, 0.000',
                '0.80, 0.20, 0.80'
            ]
        ]
    },
    // cylinder
    { meshIndex: 2, faceZ: '0.68', numMeshTransformations: 0, meshTransformations: null },
    // cylinder stack
    {
        meshIndex: 2,
        faceZ: '0.68',
        numMeshTransformations: 3,
        meshTransformations: [
            [
                '0.00,-0.40, 0.00',
                '0.000, 0.000, 0.000, 0.000',
                '1.00, 0.20, 1.00'
            ],
            [
                '0.00, 0.00, 0.00',
                '0.000, 0.000, 0.000, 0.000',
                '1.00, 0.20, 1.00'
            ],
            [
                '0.00, 0.40, 0.00',
                '0.000, 0.000, 0.000, 0.000',
                '1.00, 0.20, 1.00'
            ]
        ]
    },
    // pentagon torus
    { meshIndex: 3, faceZ: '0.25', numMeshTransformations: 0, meshTransformations: null },
    // square torus
    { meshIndex: 4, faceZ: '0.25', numMeshTransformations: 0, meshTransformations: null },
    // diamond torus
    {
        meshIndex: 4,
        faceZ: '0.25',
        numMeshTransformations: 1,
        meshTransformations: [
            [
                '0.00, 0.00, 0.00',
                '0.000, 0.000, 0.383, 0.924',
                '1.00, 1.00, 1.00'
            ]
        ]
    },
    // triangle torus
    { meshIndex: 5, faceZ: '0.25', numMeshTransformations: 0, meshTransformations: null },
    // upside-down triangle torus
    {
        meshIndex: 5,
        faceZ: '0.25',
        numMeshTransformations: 1,
        meshTransformations: [
            [
                '0.00, 0.00, 0.00',
                '0.000, 0.000, 1.000, 0.000',
                '1.00, 1.00, 1.00'
            ]
        ]
    },
    // pyramid
    { meshIndex: 6, faceZ: '0.45', numMeshTransformations: 0, meshTransformations: null },
    // upside-down pyramid
    {
        meshIndex: 6,
        faceZ: '0.55',
        numMeshTransformations: 1,
        meshTransformations: [
            [
                '0.00, 0.21, 0.00',
                '0.000, 0.000, 1.000, 0.000',
                '1.00, 1.00, 1.00'
            ]
        ]
    },
    // ethereum
    { meshIndex: 7, faceZ: '0.45', numMeshTransformations: 0, meshTransformations: null },
    // flat orb
    {
        meshIndex: 0,
        faceZ: '0.10',
        numMeshTransformations: 1,
        meshTransformations: [
            [
                '0.00, 0.00, 0.00',
                '0.000, 0.000, 0.000, 0.000',
                '1.00, 1.00, 0.01'
            ]
        ]
    },
    // wide orb
    {
        meshIndex: 0,
        faceZ: '0.63',
        numMeshTransformations: 1,
        meshTransformations: [
            [
                '0.00, 0.14, 0.00',
                '0.000, 0.000, 0.000, 0.000',
                '1.00, 0.57, 0.57'
            ]
        ]
    },
    // stack
    {
        meshIndex: 0,
        faceZ: '0.50',
        numMeshTransformations: 3,
        meshTransformations: [
            [
                '0.00,-0.40, 0.00',
                '0.000, 0.000, 0.000, 0.000',
                '0.80, 0.20, 0.50'
            ],
            [
                '0.00, 0.00, 0.00',
                '0.000, 0.000, 0.000, 0.000',
                '0.80, 0.20, 0.50'
            ],
            [
                '0.00, 0.40, 0.00',
                '0.000, 0.000, 0.000, 0.000',
                '0.80, 0.20, 0.50'
            ]
        ]
    },
    { meshIndex: 8, faceZ: '0.28', numMeshTransformations: 0, meshTransformations: null },
    {
        meshIndex: 8,
        faceZ: '0.28',
        numMeshTransformations: 1,
        meshTransformations: [
            [
                '0.00, 0.00, 0.00',
                '0.000, 0.000, 0.383, 0.924',
                '1.00, 1.00, 1.00'
            ]
        ]
    },
    { meshIndex: 9, faceZ: '0.28', numMeshTransformations: 0, meshTransformations: null },
    {
        meshIndex: 9,
        faceZ: '0.28',
        numMeshTransformations: 1,
        meshTransformations: [
            [
                '0.00, 0.00, 0.00',
                '0.000, 0.000, 0.383, 0.924',
                '1.00, 1.00, 1.00'
            ]
        ]
    },
    { meshIndex: 10, faceZ: '0.68', numMeshTransformations: 0, meshTransformations: null },
    {
        meshIndex: 1,
        faceZ: '0.50',
        numMeshTransformations: 1,
        meshTransformations: [
            [
                '0.00, 0.00, 0.00',
                '0.000, 0.000, 0.000, 0.000',
                '0.82, 1.29, 0.82'
            ]
        ]
    },
    { meshIndex: 11, faceZ: '0.40', numMeshTransformations: 0, meshTransformations: null },
    {
        meshIndex: 11,
        faceZ: '0.40',
        numMeshTransformations: 1,
        meshTransformations: [
            [
                '0.00, 0.20, 0.00',
                '0.000, 0.000, 1.000, 0.000',
                '1.00, 1.00, 1.00'
            ]
        ]
    },
    {
        meshIndex: 4,
        faceZ: '0.25',
        numMeshTransformations: 1,
        meshTransformations: [
            [
                '0.00, 0.00, 0.00',
                '0.000, 0.000, 0.000, 0.000',
                '0.70, 1.05, 1.00'
            ]
        ]
    },
    // cloud
    {
        meshIndex: 0,
        faceZ: '0.71',
        numMeshTransformations: 3,
        meshTransformations: [
            [
                '0.00, 0.33, 0.00',
                '0.000, 0.000, 0.000, 0.000',
                '0.70, 0.70, 0.70'
            ],
            [
                '-0.40,-0.19,0.00',
                '0.000, 0.000, 0.000, 0.000',
                '0.70, 0.70, 0.70'
            ],
            [
                '0.40,-0.19, 0.00',
                '0.000, 0.000, 0.000, 0.000',
                '0.70, 0.70, 0.70'
            ]
        ]
    },
    // cluster
    {
        meshIndex: 0,
        faceZ: '0.35',
        numMeshTransformations: 6,
        meshTransformations: [
            [
                '-0.30,0.55, 0.00',
                '0.000, 0.000, 0.000, 0.000',
                '0.30, 0.30, 0.30'
            ],
            [
                '0.30, 0.55, 0.00',
                '0.000, 0.000, 0.000, 0.000',
                '0.30, 0.30, 0.30'
            ],
            [
                '-0.55,0.00, 0.00',
                '0.000, 0.000, 0.000, 0.000',
                '0.30, 0.30, 0.30'
            ],
            [
                '0.55, 0.00, 0.00',
                '0.000, 0.000, 0.000, 0.000',
                '0.30, 0.30, 0.30'
            ],
            [
                '-0.30,-0.55,0.00',
                '0.000, 0.000, 0.000, 0.000',
                '0.30, 0.30, 0.30'
            ],
            [
                '0.30,-0.55, 0.00',
                '0.000, 0.000, 0.000, 0.000',
                '0.30, 0.30, 0.30'
            ],
            
        ]
    },
    // x-cluster
    {
        meshIndex: 0,
        faceZ: '0.50',
        numMeshTransformations: 5,
        meshTransformations: [
            [
                '0.00, 0.00, 0.00',
                '0.000, 0.000, 0.000, 0.000',
                '0.50, 0.50, 0.50'
            ],
            [
                '-0.50,0.50, 0.00',
                '0.000, 0.000, 0.000, 0.000',
                '0.40, 0.40, 0.40'
            ],
            [
                '0.50, 0.50, 0.00',
                '0.000, 0.000, 0.000, 0.000',
                '0.40, 0.40, 0.40'
            ],
            [
                '-0.50,-0.50,0.00',
                '0.000, 0.000, 0.000, 0.000',
                '0.40, 0.40, 0.40'
            ],
            [
                '0.50,-0.50, 0.00',
                '0.000, 0.000, 0.000, 0.000',
                '0.40, 0.40, 0.40'
            ]
        ]
    },
    // atom
    {
        meshIndex: 0,
        faceZ: '0.90',
        numMeshTransformations: 6,
        meshTransformations: [
            [
                '0.00, 0.00, 0.20',
                '0.000, 0.000, 0.000, 0.000',
                '0.70, 0.70, 0.70'
            ],
            [
                '0.40, 0.00, 0.00',
                '0.000, 0.000, 0.000, 0.000',
                '0.70, 0.70, 0.70'
            ],
            [
                '-0.40,0.00, 0.00',
                '0.000, 0.000, 0.000, 0.000',
                '0.70, 0.70, 0.70'
            ],
            [
                '0.00, 0.00,-0.20',
                '0.000, 0.000, 0.000, 0.000',
                '0.70, 0.70, 0.70'
            ],
            [
                '0.00, 0.40, 0.00',
                '0.000, 0.000, 0.000, 0.000',
                '0.70, 0.70, 0.70'
            ],
            [
                '0.00,-0.40, 0.00',
                '0.000, 0.000, 0.000, 0.000',
                '0.70, 0.70, 0.70'
            ]
        ]
    },
    // gem
    { meshIndex: 12, faceZ: '0.68', numMeshTransformations: 0, meshTransformations: null },
    //upside-down gem
    {
        meshIndex: 12,
        faceZ: '0.68',
        numMeshTransformations: 1,
        meshTransformations: [
            [
                '0.00, 0.28, 0.00',
                '0.000, 0.000, 1.000, 0.000',
                '1.00, 1.00, 1.00'
            ]
        ]
    },
    // shield
    { meshIndex: 13, faceZ: '0.10', numMeshTransformations: 0, meshTransformations: null },
    // crown
    { meshIndex: 14, faceZ: '0.90', numMeshTransformations: 0, meshTransformations: null },
    // honeycomb
    { meshIndex: 15, faceZ: '0.50', numMeshTransformations: 0, meshTransformations: null },
    // large honeycomb cluster
    {
        meshIndex: 15,
        faceZ: '0.25',
        numMeshTransformations: 3,
        meshTransformations: [
            [
                '0.00, 0.40, 0.00',
                '0.000, 0.000, 0.000, 0.000',
                '0.50, 0.50, 0.50'
            ],
            [
                '0.40,-0.20, 0.00',
                '0.000, 0.000, 0.000, 0.000',
                '0.50, 0.50, 0.50'
            ],
            [
                '-0.40,-0.20,0.00',
                '0.000, 0.000, 0.000, 0.000',
                '0.50, 0.50, 0.50'
            ]
        ]
    },
    // heart
    { meshIndex: 16, faceZ: '0.38', numMeshTransformations: 0, meshTransformations: null },
    // gear
    { meshIndex: 17, faceZ: '0.30', numMeshTransformations: 0, meshTransformations: null },
    // pentagon atom 1
    {
        meshIndex: 3,
        faceZ: '1.00',
        numMeshTransformations: 4,
        meshTransformations: [
            [
                '0.00, 0.00, 0.00',
                '0.000, 0.195, 0.000, 0.981',
                '0.90, 0.90, 0.90'
            ],
            [
                '0.00, 0.00, 0.00',
                '0.000,-0.556, 0.000, 0.831',
                '0.90, 0.90, 0.90'
            ],
            [
                '0.00, 0.00, 0.00',
                '0.000, 0.556, 0.000, 0.831',
                '0.90, 0.90, 0.90'
            ],
            [
                '0.00, 0.00, 0.00',
                '0.000,-0.195, 0.000, 0.981',
                '0.90, 0.90, 0.90'
            ]
        ]
    },
    // square atom
    {
        meshIndex: 4,
        faceZ: '0.80',
        numMeshTransformations: 4,
        meshTransformations: [
            [
                '0.00, 0.00, 0.00',
                '0.000, 0.195, 0.000, 0.981',
                '0.90, 0.90, 0.90'
            ],
            [
                '0.00, 0.00, 0.00',
                '0.000,-0.556, 0.000, 0.831',
                '0.90, 0.90, 0.90'
            ],
            [
                '0.00, 0.00, 0.00',
                '0.000, 0.556, 0.000, 0.831',
                '0.90, 0.90, 0.90'
            ],
            [
                '0.00, 0.00, 0.00',
                '0.000,-0.195, 0.000, 0.981',
                '0.90, 0.90, 0.90'
            ]
        ]
    },
    // triangle atom
    {
        meshIndex: 5,
        faceZ: '0.80',
        numMeshTransformations: 4,
        meshTransformations: [
            [
                '0.00, 0.00, 0.00',
                '0.000, 0.195, 0.000, 0.981',
                '0.90, 0.90, 0.90'
            ],
            [
                '0.00, 0.00, 0.00',
                '0.000,-0.556, 0.000, 0.831',
                '0.90, 0.90, 0.90'
            ],
            [
                '0.00, 0.00, 0.00',
                '0.000, 0.556, 0.000, 0.831',
                '0.90, 0.90, 0.90'
            ],
            [
                '0.00, 0.00, 0.00',
                '0.000,-0.195, 0.000, 0.981',
                '0.90, 0.90, 0.90'
            ]
        ]
    },
    // hexagon torus
    { meshIndex: 18, faceZ: '0.25', numMeshTransformations: 0, meshTransformations: null },
    // hexagon atom 1
    {
        meshIndex: 18,
        faceZ: '0.80',
        numMeshTransformations: 4,
        meshTransformations: [
            [
                '0.00, 0.00, 0.00',
                '0.000, 0.195, 0.000, 0.981',
                '0.90, 0.90, 0.90'
            ],
            [
                '0.00, 0.00, 0.00',
                '0.000,-0.556, 0.000, 0.831',
                '0.90, 0.90, 0.90'
            ],
            [
                '0.00, 0.00, 0.00',
                '0.000, 0.556, 0.000, 0.831',
                '0.90, 0.90, 0.90'
            ],
            [
                '0.00, 0.00, 0.00',
                '0.000,-0.195, 0.000, 0.981',
                '0.90, 0.90, 0.90'
            ]
        ]
    },
    // plane
    {
        meshIndex: 1,
        faceZ: '0.10',
        numMeshTransformations: 1,
        meshTransformations: [
            [
                '0.00, 0.00, 0.00',
                '0.000, 0.000, 0.000, 0.000',
                '1.00, 1.00, 0.01'
            ]
        ]
    },
    // v
    { meshIndex: 19, faceZ: '0.40', numMeshTransformations: 0, meshTransformations: null },
    // upside-down v
    {
        meshIndex: 19, faceZ: '0.40', numMeshTransformations: 1, meshTransformations: [
            [
                '0.00, 0.20, 0.00',
                '0.000, 0.000, 1.000, 0.000',
                '1.00, 1.00, 1.00'
            ]
        ]
    },
    // i
    { meshIndex: 20, faceZ: '0.31', numMeshTransformations: 0, meshTransformations: null },
    // rotated i
    {
        meshIndex: 20, faceZ: '0.31', numMeshTransformations: 1, meshTransformations: [
            [
                '-0.18,0.19, 0.00',
                '0.000, 0.000,-0.707, 0.707',
                '1.00, 1.00, 1.00'
            ]
        ]
    },
    // coffee
    { meshIndex: 21, faceZ: '0.95', numMeshTransformations: 0, meshTransformations: null },
    // flower
    { meshIndex: 22, faceZ: '0.24', numMeshTransformations: 0, meshTransformations: null },
    // ghost
    { meshIndex: 23, faceZ: '0.80', numMeshTransformations: 0, meshTransformations: null },
    // little sphere
    { meshIndex: 24, faceZ: '0.68', numMeshTransformations: 0, meshTransformations: null },
    // crystal
    {
        meshIndex: 24, faceZ: '0.55', numMeshTransformations: 1, meshTransformations: [
            [
                '0.00, 0.00, 0.00',
                '0.000, 0.000, 0.000, 0.000',
                '0.77, 1.25, 0.77'
            ]
        ]
    },
    // shroom
    { meshIndex: 25, faceZ: '0.75', numMeshTransformations: 0, meshTransformations: null },
    // stone
    { meshIndex: 26, faceZ: '0.49', numMeshTransformations: 0, meshTransformations: null },
    // sword
    { meshIndex: 27, faceZ: '0.17', numMeshTransformations: 0, meshTransformations: null },
    // tv
    { meshIndex: 28, faceZ: '0.32', numMeshTransformations: 0, meshTransformations: null },
    // unihorn
    { meshIndex: 29, faceZ: '0.86', numMeshTransformations: 0, meshTransformations: null },
    // slime
    { meshIndex: 30, faceZ: '0.82', numMeshTransformations: 0, meshTransformations: null },
    // skull
    { meshIndex: 31, faceZ: '0.29', numMeshTransformations: 0, meshTransformations: null }
];

export const AVATAR_ANIMATIONS = [
    'hover-normal',
    'hover-spin-normal',
    'hover-normal',
    'hover-spin-normal',
    'hover-big',
    'hover-spin-big'
]

export const getAnimationIndexForSizeAndColor = (color: number, size: number) => {
    const isGrayScale = color >= avatarHexes.length - 5;
    return (size * 2) + (isGrayScale ? 0 : 1);
};

export const bodyLayoutBytes = bodyData.map((body) => {
    const meshIndexBuffer = Buffer.alloc(1);
    meshIndexBuffer.writeUInt8(body.meshIndex, 0);
    const faceZBuffer = Buffer.from(body.faceZ, 'utf8');
    const numberOfMeshes = body.numMeshTransformations;
    const numberOfMeshesBuffer = Buffer.alloc(1);
    numberOfMeshesBuffer.writeUInt8(numberOfMeshes, 0);
    // For each mesh in a body, a set of strings representing translation, rotation, and scale
    let concatenatedBodyTransformations = '';
    for (let bodyTransformationIndex = 0; bodyTransformationIndex < numberOfMeshes; bodyTransformationIndex++) {
        concatenatedBodyTransformations += body.meshTransformations[bodyTransformationIndex].join('');
    }
    const bodyTransformationsBuffer = Buffer.from(concatenatedBodyTransformations);
    if (bodyTransformationsBuffer.length !== (16 + 26 + 16) * numberOfMeshes) {
        console.error('something seems wrong with body transformation buffer');
    }
    return Buffer.concat([meshIndexBuffer, faceZBuffer, numberOfMeshesBuffer, bodyTransformationsBuffer]);
});

// TODO parse out common denominators
// const pngPrefix = 'iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAA';
let faceStrings = [
        // happy
        "iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAATElEQVRIx+2RMQoAIAwDTf//Z50ElaQdOgm5rV6JEccwbXBNU5wnFnSBRQgLsZCHHzaKR5UWzw0gU2qj+wtB+yCtDx3QbvBlgDHGbBZrSwoZIgKb8AAAAABJRU5ErkJggg==",
        // cute
        "iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAAWElEQVRIx+2TQQoAIQwDk/7/z/WyVMSWLujBQ+YkNgyWICCOYZw8vV1JMtxGBOCpIjJOgF+Gm7lSLJmpsOah1eaRsXbXRmGnLUhwQcCiOP4ol1f+ghDiFQbOfxQURvzEXAAAAABJRU5ErkJggg==",
        // cuter
        "iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAAP0lEQVRIx+2RuwoAIAwDr/n/f66zj4Ki4JLbwmUILRgDMeQ8NbEsBZCdK42Wu7JcPBntFiuj2yPq+xeMMeYZDS6SDAgMU6GzAAAAAElFTkSuQmCC",
        // annoyed
        "iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAAQElEQVRIx2NgGAUDCphwiP9n+E9QLwE1/4mwHqaGEY8ORoJmMuL2B8UBQTRgxONBRoJBMCi8MApGwSgYBYMHAAC6iwoHWgKN+wAAAABJRU5ErkJggg==",
        // sandbag
        "iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAAKElEQVRIx2NgGAUUA0Y0/n8c4jjlmCh1wagBowZQxYBRMApGwSiAAQD23AIWWK2iJQAAAABJRU5ErkJggg==",
        // tiny
        "iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAAKElEQVRIx2NgGAWjYDAARixi/7HKYBdlYKLUBUyjkTAKRsEoGAVwAAARIQIGIbRCGgAAAABJRU5ErkJggg==",
        // expressionless
        "iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAAKklEQVRIx2NgGAWjYFgARgYGBgaG/zhlEACHGiZKXcA0GgmjYBSMguEDAJuxAgZHqARwAAAAAElFTkSuQmCC",
        // crying
        "iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAATElEQVRIx+2TMQ4AIAgDhf//uc5GixjRqbeZJvUSoDUhCrDhBZrQzG8NfGllgbHtCxB8iIzBUYXXzgSBA8meTCGzMaTA/mwvdMBCzHTgQQsPAHR8zwAAAABJRU5ErkJggg==",
        // relieved
        "iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAAQElEQVRIx2NgGAWjYPCA/wz/8YjilWVCEkBXgJuHxGdEEWBEU0CELCNOO5Dl8MjiVsSI10uMowlnFIyCUUB1AACUbRP65yLVUAAAAABJRU5ErkJggg==",
        // monocle
        "iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAAbUlEQVRIx+1TQQ7AIAgrxv9/ubstLFMGOE222JMiVqEF+DxErdmJuwho7Bzg5fV+LHA9RMHEyYmqktjszUMnitks8fwgAt6Ja9o1qoRB0FSB02UsRiKXWFma8gSGSZTfUuMcrvZ1H/yAYGMDAA5TEyIKXZyLhwAAAABJRU5ErkJggg==",
        // ><
        "iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAAVklEQVRIx+2TMQ4AIAgDC/H/X66jiQpidGDgRntogAgUuSB477UlBMQtntCI5CViKsFEnHfkcGZesOq0bX1d3fcWnobIw2S2hgbbMpMWLh4569cXRUY6wIUVEeytwYwAAAAASUVORK5CYII=",
        // grump
        "iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAAMElEQVRIx2NgGAXDADBC6f94ZP/j08tEqQuGgQFUB/9xhjkOeabRlDwKRsEoGDQAAIIsBginVpXPAAAAAElFTkSuQmCC",
        // ;)
        "iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAARklEQVRIx+2RMQ4AMAgC0f//mW4dDI017chtikGDgDFAlJqH/qUBd4/CQpqnMKVcRa1nM1xvi6rnOK/oMxjF+PwFY4z5xgKSQQwJlbU/2AAAAABJRU5ErkJggg==",
        // OO
        "iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAAZUlEQVRIx+2TwQrAIAxD2/z/P3cXYWZqJljw0nixPmkhRrPSsZyqWJzvULrAe0m9O3SaETRH09Yz2nrrDYpJ/+9MSTH1IlY2jRT2b6ikOM0BsoI0GtU/laBpOUhIYsJfKJVKN/UA09A58gw+sT4AAAAASUVORK5CYII=",
        // lashes
        "iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAAKklEQVRIx2NgGAWjYDCB/+TqYEERYCTdOkY8riBKjmk09kbBKBgFwwcAAGXSBgXV2mT1AAAAAElFTkSuQmCC",
        // nouns
        "iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAAPklEQVRIx2NgGAUDDxhReP/xqMIhx0SpC1hwuuk/Hvf+p6oL/hOhCo8aKoUB4wDGwsAbMPApcRSMglEwWAAAQaIKGQ+ui8cAAAAASUVORK5CYII=",
        // hypnotized
        "iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAAiElEQVRIx+1TQQ7AIAgTs/9/ubs4VxDQxCs9WQuVALZWuIbQGaFiNauOEBwyxYVeEAqTceNpWiXH35e51czNYzwxGRTjGpTa3cJA5XG6LKoy+MLFmRXoZYXevHnIMrbIevaAk72+h9bdSYbTuI11PqpsyOEi5au0LNJmXTMmxx8Gu89UKBSu8AKafmLiklG1CAAAAABJRU5ErkJggg==",
        // censored
        "iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAAI0lEQVRIx2NgGAUDDxgZ/lNmABOlLhg1YNSAUTAKRsEoQAYAAIUBE/LqtHgAAAAASUVORK5CYII=",
        // bandit
        "iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAAMklEQVRIx2NgGAUDDxgZ/lNmABOlLmDB4iYI+E+cOMUuGHgDBj4WBt6AUTAKRsEogAEA+Y8EEwHLJ9IAAAAASUVORK5CYII=",
        // sunglasses
        "iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAAPklEQVRIx+2SMQ4AMAgCgf//mY6dKoMdufUMISpQCkB4F6AQz2TvgJ8NOVmFhk5W2yVqfwXELYxW/eRSyi8OYnsJDuZcfrYAAAAASUVORK5CYII=",
        // eyepatch
        "iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAAPklEQVRIx+2SQQoAMAjD0rH/f9ndhzgZHpu7bQqCMSAA4v96zRhQeKgO2O2qyENHJ2Qj9AoYNrgd5D83xvQ5H0wFDyLkagQAAAAASUVORK5CYII=",
        // stars
        "iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAAYklEQVRIx+2SwQ7AIAhDKfH/f5ldDSnUxV2W0Ju+gKViNsoKi3ccCbPblvutZZD+lQfKkQB7oOVelEH4xp4BRFgtB50vRD4bdxGWKY62BKIlPtqDuDkvYrj6exzuxmg0+qceGsUaF9bP/vAAAAAASUVORK5CYII=",
        // hearts
        "iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAAZklEQVRIx+1RMRLAIAgL/v/P6dJ69YTEzYUsHiSABKBxH/G+FJHk45f4YhbtU35NYBNafhSr0aw++VE6Q+McVYPj+buJ6kYpryRh/hSriKJc8NWUMM5ELqQoP+EB0FyA9kKNRuMSHu/HIAdo2AhFAAAAAElFTkSuQmCC",
        // hashtag
        "iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAALklEQVRIx2NgGAWDDfxn+I9CEyHHRKmdjEg24JbFI8c0GgbDIQxGwSgYBaMABgC+Phv1Pe9OmgAAAABJRU5ErkJggg==",
        // plus
        "iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAAMUlEQVRIx2NgGAXDADCi8f9jFcUjy0SpC5io54X/eL2HU3YweWHIxsIoGAWjYBTAAAAvCwYQ8wlh3QAAAABJRU5ErkJggg==",
        // pleased
        'iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAANklEQVRIx2NgGAWjgAqAEY3/n1QZRhyK0OVwymAqYsRg45NhYMLhJUacnmUcjfdRMApGwbAFAHsTCAreprWYAAAAAElFTkSuQmCC',
        // unhappy
        'iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAAPklEQVRIx2NgGAWjYDAARiT2f5wyeGSZCBpLQJYJq4L/eLX/x23Xf7xuwCqL3ae4vPCfCA+OglEwCkYBuQAAXl4ICn7Vx50AAAAASUVORK5CYII=',
        // pretty
        'iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAAXklEQVRIx+2SOw4AIAhDKfH+V9bNoEJJjJPhbfwEKiLFM/ptRTMOTDdoEWxDhBMgnRFrGn8ijOrmBNnajSoRsVOJDxHzv3CjGgwrdBXXeCLiBXEXfgfgafklFkXxHwNO0xYTnBf/tgAAAABJRU5ErkJggg==',
        // cute-crying
        'iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAAcUlEQVRIx+2SOw7AMAhDY9T7X9mdOiQGV5UiZSjewjMofMZonReWN9OooRDsSwvFZMBkXIunNKQqbLNCI/3gGjM0JEQ7QKFXMWXaHVBbgF2xoZEkcDBJKWiICeUeHoZsC+83WtAo8Ze73CNu9rVaP9MNzAwcHEbd1uYAAAAASUVORK5CYII=',
        // blushing
        'iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAASklEQVRIx+2TMQ4AIAgDC///c51VSEAHHXobuZIARkAIwJaaXWNhyABwcqnxcC6mE2/Gq8HM+O0R/fkrVLZupHnezPby1C8U4i8GslESAtczuekAAAAASUVORK5CYII=',
        // pleading
        'iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAAXklEQVRIx+2SUQrAMAhDjXj/K7vvGpdBKRSG+atPQqOaje4L5Z1tVVAQ1tZEsTRgaazmLXVyhQxL1NsP1pqgTqWUAyQaL1NOuYPkCJArFjRkdvumB+9g8xJHo9Fv9ABrIRoSC0gVuQAAAABJRU5ErkJggg==',
        // tall-cute
        'iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAASklEQVRIx2NgGAWDD/xn+E+JPET6PynyTCjSEMCIwwis8ixoihgJeAFDngmHLbg9wYDfAJLBMDCAEUdEMRCISFqlxFEwCkbBEAYAjrIYACDO0gYAAAAASUVORK5CYII=',
        // little
        'iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAALUlEQVRIx2NgGAWjYDAARjT+fxziOOWYiDAUrwwTHpuIkmEajcVRMApGwfABAAPbBAglHENUAAAAAElFTkSuQmCC',
        // diamond
        'iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAAYUlEQVRIx+2TMQ7AIAwDMf//s1kYUBsbaKnUId7gghU5oZTUB+IeRVgA+xzagNJYUsj2YJvHvYz9RGke0mqiow2Wo49OHjMKO7wFWsPIcLkz9OAUDuzBo018/RdSqdRf1ADsaBwMmZrHfwAAAABJRU5ErkJggg==',
        // sparkle
        'iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAAW0lEQVRIx+2TQQ4AIQgDHeP/v6zHlQRqNsbogV4HTClYSuqA+j+KW4BsN7TuGiYwiLSP/8BnsMvhDG1hdHOZoCySZ0WrGQQ3IUkJd4y8AI5s4c4hbf+FVCr1igYVxhgSU3wq9wAAAABJRU5ErkJggg==',
        // angry
        "iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAASUlEQVRIx+2RMQ4AIAgDC/H/X9bFSW3BvbeQQEkuABgDxK7z6jCO5CCBkKsPA5QmZBJCMzpeiY6X6GbrXJOHsvhOZSUNjDHmiwWEvAoRu4k24gAAAABJRU5ErkJggg==",
        // xx
        "iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAAWUlEQVRIx+2RQQ6AMAgEd/n/n9ejUVhSYw/GMCfKNLQAMHwJQSbjDYC4iTpuDJNgijtzKXBK2eLJMHX30LAYZp035vUPwr6hNbNxC7JndTfDToSLZhiGv3AAJLUmBJ9kQ0gAAAAASUVORK5CYII=",
        // scary
        "iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAAWUlEQVRIx+2RQRLAIAgDTf7/Z3vQcbQFR+Kx7DWJBiglaVQ9RfmJnqDYYrgpDTI5KexicTG8zpeDwYt8VIaOaihwJBzE4TWw/3J6YWPANg6rar0YMEmS3/MAQacYAjIxYqIAAAAASUVORK5CYII=",
        // awoken-+
        'iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAAMklEQVRIx2NgGAXDADCi8f9jFcUjy0SpC5io5wVk52E6FafsYPLCkI2FUTAKRsEogAEAEbwIEHb7LAsAAAAASUVORK5CYII=',
        // ancient
        'iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAAUklEQVRIx+2RQQrAMAgEx9D/fzm9FVJXW0hPZeeiYYKYDZifMZnFqTaMNGStjybEpbjqCzO+TkH3jTnEiBAJlGb7CSqoe9+ZtEHI3+mNMcYAcALpvRwB+e8QwwAAAABJRU5ErkJggg==',
        // void
        'iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAATklEQVRIx+2SMQoAMAgDjf//czp1sEVRCp1yq0lQopl4BsWMHR0KO0IIZgE0hA1SLdr2RO2N+0v8tYWPAeMWTh0nLdj1AZxu0P5EIYTYLM9hDRBZgmzMAAAAAElFTkSuQmCC',
        // corpse
        "iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAAf0lEQVRIx+2TQRKAIAwDsx3+/2W86MERai3geLD3LkkapH8kqY5s2gCiSgcgg9g3SscIUavF4RPJyULhOgYt4NPNx0Y78A0A6W3uFNDtxBsZcNvME4CM/76Ctnd8C2TebynARTHzClwBrK5yI9xJRWJ+E1n3nfEBxBvwRAFaNxv87A5H4c9zMQAAAABJRU5ErkJggg==",
        // masked
        "iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAAo0lEQVRIx92USxKAIAxDSe5/57oFTEoVFo4sHOH1R8q0td+taPGMY8LqNOUQ2IWQHBKrEIbT4IpaXQBVXCzVib6C3h02q6AYcs2KQO4GDxrZILOLfxqdw3xvlpRSRfqMBkphNGsCQ4WI/tbWhmnL8qctr1DrwjIA6qcsuxvC3QmE0iRIpsJ2BSxlTao/VMGbGnCoCyyrb14EHzSwZLmeztE+ti6NXCgvGxKL7wAAAABJRU5ErkJggg==",
        // matrix
        "iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAAe0lEQVRIx+1TQQ7AIAiD/v/P3XHGUWGTZDusiSFCVSho1gzeZSB0c/JRcgxD4LQeZDJ6B4vdmtEnXbSKDKZXLBhNGujUs2IN4QGWh4woThyftZH5eMN8S0Nv6oLKwvMoJrKJvYzi4nb55iL6lb+gVVjog1S+kpQ/fryNA8PFU+f2sKyhAAAAAElFTkSuQmCC",
        // mime
        "iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAAZUlEQVRIx+1SQQrAIAxryv7/5XryMNJipSpjmJMaTJqoyEaYsyI8g6vvE4wFLDETfAGbjIYj5SUYrbqVBTBRkcsgTJlkNPSwHANyAO1ihgbtPpw2ZModlF/hBz9R5Ys4W+LFxRI0uPYiFBPKABcAAAAASUVORK5CYII=",
        // cyclops
        "iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAAYUlEQVRIx+2TwQ7AIAhDxfj/v/x22sGhCJHd6EnTSkqR1gqyZXArN88x72Zdlgx+H0SYYYpQPjl74HNi6l956Ldj7MdZyE0BO9L/WtDZi89N0j94hRLLInUXUraxUCgE8QAtwSAA0IAbEwAAAABJRU5ErkJggg==",
        // awoken-creature
        'iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAAR0lEQVRIx2NgGAWjgIGBEY3/H6socbJQBf/hComSZcIwH5ONV5aJ0jBgwrCHEYcHcMgy4nAmI84gRJOlciyMglEwCkYBBQAAI6cT/njd4F0AAAAASUVORK5CYII=',
        // creature
        'iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAAQElEQVRIx+2RIQIAMAgCkf//2bWFoRYXuaSCBgSMAeLps5wOKsUQ11iti0q5r/WocpsB/4aYbbituv6CMcZ84wAWQg4GpzZ1+AAAAABJRU5ErkJggg==',
        // skull
        'iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAASElEQVRIx+2RMQ4AIAgDwfj/L9eZSNUQJ+1tcA1DMRMP4GECNdR5GphPUNtoYAfigTLtXolY1kt9DwuUfscLOtomMZScEOJ7BnEgDwfpCUKGAAAAAElFTkSuQmCC',
        // skull-awoken
        'iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAAUklEQVRIx2NgGAXDADCi8P7jlMEpx4hVAaYR/5FEkNkMTDi143YtsjFwA4jV/h/dbcQbgOkJAmGALRCxuILiWMDnXOJEsSj7T5bcKBgFo2DEAwCIWhUF+1goHgAAAABJRU5ErkJggg==',
        // cat-eye
        'iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAAbklEQVRIx+2TzQ6AIAyDN97/nT8vhojMDmJMPKwn0nV/BcwKr+GPEdaULpL9PPnALBSg8wwqIn0T6VEzMk+4SOgMYTyYAGlrOEWTnmBMBV17QHqdcoXcpmlJlxJuKvIV1BShxZ+8xK2/UCgU/oIDgvcjCUOgE0gAAAAASUVORK5CYII=',
        // empty
        'iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAAQklEQVRIx2NgGAUDDxjR+P+xiuKRZcSQxm80hiwjDgX4DUeSZaJWGPwnV5ZiFzBRLxoHOhCpkA7ITImjYBSMgmEDAIsrDhAjA8+vAAAAAElFTkSuQmCC',
        // chain-skull
        'iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAARElEQVRIx2NgGAXDDvxn+E+qGiZK7WREMhmXDF55il3AgtVN/6GYEc12RkyXDIMwYMRqCyPONIAhzzSae0bBKBgFUAAAQ0EODWtxII0AAAAASUVORK5CYII=',
        // 0xmon
        'iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAAcklEQVRIx+1TQQ7AMAhC/v9ndu02qabdZUm5qaDVUCCDoFYOAOGgSTQgpvJIo1aDUaQZ0ze4P9vyiE18uIJekT/iwGW69VMQSdXcQGa5cI6IUloMYOnBosIu0WXZnqXaB1qpsWlr25rtn7Ey6ODg4E+4AAatIRAvvkGJAAAAAElFTkSuQmCC',
        // warrior-1
        'iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAAQElEQVRIx2NgGAW4wH+G/3j5RGn/j5OPBJjwGIKfT1svUDH48PGICD58PDyB+J9oHi28MJoSB0dKHAWjYBSQBQBQYDfPoll09wAAAABJRU5ErkJggg==',
        // warrior-2
        'iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAAOElEQVRIx2NgGPbgP8N/yrXjNYKJCEMG0guDIdzx8YgId3w8PLHwn2geLbwwmhdG88IoGAVDGAAA1yAn3+1pblsAAAAASUVORK5CYII=',
        // warrior-3
        'iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAAPUlEQVRIx2NgGIbgP8N/suRQlPwnXo4Jq0J8FtDaC4MvFvDxiAhpfDyiY+E/ZbFAshdG88JoXhgFo2AIAwBQYDfPA8UttwAAAABJRU5ErkJggg==',
        // elder
        'iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAAVklEQVRIx2NgGMzgPwMDw38oSbYRBLUzEnABRM1/3OqYiPQKWS5AdgO9AhGfFiKNw6cEqxwj0eGOQ46J5HD/jz8W8IU7EXFChUAczQsDnxdGwSgYuQAAttI73StJSA0AAAAASUVORK5CYII='
];
// faceStrings = faceStrings.map(faceString => faceString.substring(pngPrefix.length));

export const faceBytes = faceStrings.map(faceString => Buffer.from(faceString, 'base64'));

export const HYALIKO_AVATAR_URL = 'https://api.hyaliko.com/hyaliko/';
export const HYALIKO_COLLECTION_INFORMATION_URL = 'https://api.hyaliko.com/hyaliko/information';
export const HYALIKO_MERKLE_PROOFS_URL = 'https://api.hyaliko.com/hyaliko/getMerkleRoots';